import { APP_BASE_HREF } from '@angular/common';
import { PaginatorState } from 'primeng/paginator';
import { Location } from '@angular/common';
import $ from 'jquery';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  Inject,
  Injectable,
  Input,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Utils } from '@app/_core/helper/Utils';
import { AppService } from '@app/_core/services/app.service';
import { DialerService } from '@app/_core/services/dialer.service';
import { ManagerService } from '@app/_core/services/manager.service';
import { QueuesService } from '@app/_core/services/queues.service';
import { TmQueueService } from '@app/_core/services/tm-queue.service';
import { UserService } from '@app/_core/services/user.service';
import { HubService } from '@app/pages/hubs/common/HubService';
import { CaseLockConfirmationComponent } from '@app/pages/common/case-lock/case-lock.component';
//import { Twilio } from 'twilio';
declare const Twilio: any;

import { HttpClient } from '@angular/common/http';
import { FormDataService } from '@app/_core/services/form-data.service';
import { LoaderService } from '@app/_core/services/loader.service';
import { EMPTY, Observable, Subject, Subscription, catchError, finalize, map, takeUntil } from 'rxjs';

import { Field } from './user-information/user-information.component';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { CurrentStatusMessageComponent } from '@app/pages/dashboard/current-status-message/current-status-message.component';
import { AdditionalInfoService } from '@app/_core/services/additional-info.service';
import { IdentifyUserComponent } from './cases/identify-user/identify-user.component';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { WindowsWrapperService } from '@app/_core/services/windows-wrapper.service';
import { CallTranscriptComponent } from '@app/pages/common/call-transcript/call-transcript.component';
import { ConfirmDialogComponent } from '@app/pages/common/confirm-dialog/confirm-dialog.component';
import { MainControllerComponent } from 'src/app/pages/queue/dialer/MainController.component';
import { DialerComponent } from '@app/_core/components/dialer/dialer.component';
import { ConfigService } from '@app/config.services';
import { FlexibleStoreService } from '@app/_core/services/flexible-storage.service';
import { ResponseHandler } from '@app/_core/helper/ResponseHandler';
import { debug } from 'console';
import { CustDatePipe } from '@app/_shared/pipes/safe.pipe';
import { TaskMenuComponent } from '@app/pages/common/task-menu/task-menu.component';
import { HeaderService } from '@app/_core/services/header.service'; 
import{NotesHelper} from '@app/_core/helper/NotesHelper';
import { ChatbotService } from '@app/pages/common/chatbot/chatbot.service';
import { cloneDeep } from 'lodash';
import { environment } from '@environments/environment';
import { TranscriptService } from '@app/_core/services/transcript-service.service';
interface PageEvent {
  first: number;
  rows: number;
  page: number;
  pageCount: number;
}

// child-component.interface.ts
export interface ChildComponent {
  getFormData(): any;
  emitFormData(): any;
}

let QueueInteractionType: any = '';
let queueDialerType: any = '';
@Injectable({ providedIn: 'root' })
@Component({
  selector: 'app-case-detail',
  templateUrl: './case-detail.component.html',
  styleUrls: ['./case-detail.component.scss'],
  providers: [CustDatePipe],
})
export class CaseDetailComponent implements OnInit, AfterViewInit, OnDestroy {
  enableKBChatbot: boolean = environment.enableKBChatbot;
  modalRef?: BsModalRef;
  //@Output() ENABLECONTROLS: EventEmitter<any> = new EventEmitter<any>();
  //@Output() Transfer_SUBMIT_CALL: EventEmitter<any> = new EventEmitter<any>();
  @Output() notFoundAddNew = new EventEmitter<any>();
  @Output() emitBackClicked = new EventEmitter<number>();

  newUserCases: any[] = [];
  updatedFormData: any;
  selectedTab: any;
  menu: any = [];
  menuList: any = [
    // { id: 1, label: 'User Information' },
    // { id: 2, label: 'Cases' },
    // { id: 3, label: 'Disposition & Notes' },
  ];
  subMenuList: any = [
    {
      MenuName: 'additionalInformation',
      MenuLabel: 'Additional Information',
      SubMenu: [
        { Name: 'memberInformation', Label: 'Member Information', IsSelected: false, IsDisabled: false },
        { Name: 'providerInformation', Label: 'Provider Information', IsSelected: false, IsDisabled: false },
        { Name: 'claims', Label: 'Claims', isSelected: false, IsDisabled: false },
      ],
    },
  ];
  crmUserID: any;
  defaultCount = 10;
  searchedUserData: any = {};
  userInfo: any = {};
  data: any = {};
  showData: any = {};
  phoneNo: any = '+919902897172';
  device: any;
  callStatus: any = 'Connecting...';
  status: any;
  showDialer: any = false;
  waitingForInboundCall: any = false;
  selectedCallOption: any;
  callOptions: any;
  selectedCaseId: any;
  activityId: any;
  clientAbbreviation: any = '';
  disableSubmitButton: boolean = false;
  loading: boolean = false;
  isSubmittingCaseDetails: boolean = false;
  rightPanelTabs: any = [
    { id: 1, label: 'History', isSelected: true },
    { id: 2, label: 'Script / Info' },
    { id: 3, label: 'Transcript', isDisabled: true },
  ];
  callDuration: any = 0;
  activeRightPanelTab: any = 1;
  callHistory: any;
  scriptInfo: any;
  callHistorySearchTerm: string = '';
  first: number = 0;
  rows: number = 10;
  paginatedData: any;
  currentPage = 1;
  totalRecords = 0;
  loadedItemCount = 0;
  TotalItemCount: number = 0;
  collapseAll: boolean = false;
  audio: HTMLAudioElement;
  playAudioBtnText: string = 'Preview';
  caseDetailsConf: any;
  @ViewChildren('child') children: QueryList<ChildComponent>;
  allDynamicTabsData: any = {};
  IsEnableCall: boolean = false;
  showDropDown: boolean = false;
  IsVoicemailNav: boolean = false;
  selectedUserID: any;
  showSearchDialog: boolean = false;
  externalUserID: any;
  userID: any;
  searchData: any;
  dataToDisplay: any[] = [];
  @Input() URL: string;
  selectedSubmenu: string = '';
  // selectedSubmenu: any={
  //   Name:"",
  //   Label:"",
  //   isSelected:false,
  //   isDisabled:false
  // };
  showElsePart = true;
  subMenulstSelected: any = [];
  mainMenuListAdd: any = [];
  errorMessage: string;
  formDataValid: boolean = true;
  subs: Subscription[] = [];
  IsDisableHeader: boolean;
  showhidebackbtn: boolean = true;
  isButtonsReadOnlyMode: boolean = false;
  isExternalTransfer: any;
  queueType: any;
  escalatedQueueType: string = '';
  display: string = 'none';
  invalidFields: any = [];
  invalidCaseFields: any = [];
  isRecordLoaded: boolean = false;
  recordingDetails: any;
  CaseID: any;
  recordingIndex: string = 'clip2';
  displayVoiceMailDetails: { id: number; label: string; value: string }[] = [];
  searchMemberObject: { type: string; value: any };
  inboundNumber: string;
  addSearchParameterArray: any;
  user: any;
  SelectedQueueName: string = '';
  isCallStarted: boolean;
  currentActionItemConfData: any;
  //activeVoiceMailTab: any;
  activeVoiceMailTab: string = 'details';
  currentQueueData: boolean = false;
  newCallSnd = new Audio('https://common.cts-connect.com/Audio/ding-ding.ogg');
  ShowManualInboundcallAlert: boolean = false;
  IncomingCallAlerttext: any = '';
  countdownField: any = '';
  callAlertInterval: any = null;
  ActionItemID: any = '';
  selectedQueueId: any;
  automatedQueue = false;
  conference = false;
  IsDisableSubmitPauseButton: boolean = true;
  IsDisableStartCall: boolean = false;
  IsVoiceMailNavigation: boolean = false;
  followUpItem: any = null;
  transferCaseID: any;
  triggerType: string;
  showChangeUser: boolean = false;
  ConfirmUserNav: boolean = false;
  isFreeDialer: boolean = false;
  //keypad start
  dialpad: boolean = false;
  addressBook: boolean = false;
  showModal: boolean = false;
  CallPrompt: boolean = true;
  newUser: string = 'New User';
  selectedData: any = {};
  contactNumList = [];
  isUserLevelLocked: boolean = false;
  numberPad = [
    { number: '1' },
    { number: '2', digit: 'ABC' },
    { number: '3', digit: 'DEF' },
    { number: '4', digit: 'GHI' },
    { number: '5', digit: 'JKL' },
    { number: '6', digit: 'MNO' },
    { number: '7', digit: 'PQRS' },
    { number: '8', digit: 'TUV' },
    { number: '9', digit: 'WXYZ' },
    { number: '*' },
    { number: '0', digit: '*' },
    { number: '#' },
  ];
  inputValue: string = '';
  //keypad end
  @Input()
  Heading: any;
  //user: any;
  company: any;
  showSearch: boolean;
  // activityId: any;
  userId: any;
  queueID: any;
  hideUserInformationTab: boolean = true;
    isRightPanelCollapsed: boolean;
    // Call disposition properties
    callDispositionOptions: { label: string; value: number }[] = [
        { label: '-Select One-', value: 0 },
        { label: 'No Answer', value: 1 },
        { label: 'Left Voicemail', value: 9 },
        { label: 'Wrong/Bad Number', value: 5 },
        { label: 'Line Busy', value: 21 },
        { label: 'Dropped Call', value: 23 }
    ];

    // Phone validation modal properties
    showValidationModal: boolean = false;
    validationModalDisplay: string = 'none';
    validationErrorMessage: string = '';
    selectedCallDisposition: any = this.callDispositionOptions[0];
  // modalRef?: BsModalRef;
    callNotes: string = '';

    // Disposition Countdown Timer properties
    dispositionTimerInterval: any = null;
    dispositionTimerSeconds: number;
    dispositionTimerDuration: number;
    showDispositionTimeoutModal: boolean = false;
   // showDispositionCountdownTimer: boolean = false;
    showAddMoreTime: boolean = false; 
    isCallOnHold: boolean = false;
    holdCallDuration: string = "0:00";
    private destroy$ = new Subject<void>();
    isClient_BCH_PCH_AHP: boolean = false;
    isCaseHistorySearchActive = false;
    voicemailTranscriptSpeaker: string = '';
    voicemailTranscriptDate: string = '';
    voicemailTranscript: string = '';
  constructor(
    private headerService: HeaderService,
    private CustDate: CustDatePipe,
    private cdr: ChangeDetectorRef,
    private userService: UserService,
    private router: Router,
    private dialerService: DialerService,
    private queueService: QueuesService,
    @Inject(APP_BASE_HREF) public baseHref: string,
    private route: ActivatedRoute,
    private tmQueueService: TmQueueService,
    private appService: AppService,
    private managerService: ManagerService,
    private transcriptService: TranscriptService,
    private hubService: HubService,
    private http: HttpClient,
    private location: Location,
    private configService: ConfigService,
    private formDataService: FormDataService,
    private loaderService: LoaderService,
    private modalService: BsModalService,
    private additionalinfoService: AdditionalInfoService,
    private webStorageService: WebStorageService,
    private utils: Utils,
    private WindowsWrapper: WindowsWrapperService,
    private mainController: MainControllerComponent,
    private dialerComponent: DialerComponent,
    public bsModalRef: BsModalRef,
    private flexStore: FlexibleStoreService,
    private notesHelper:NotesHelper,
    private chatbotService: ChatbotService
  ) {
    // Initialize timer values based on configurable duration
    this.setDispositionTimerDuration(40);    
    this.appService.selectedQueueName.subscribe(res => {
      this.SelectedQueueName = res;
    });
    this.dialerService.phoneNo.subscribe((phoneNumber: string) => {
      this.inboundNumber = phoneNumber;
    });
    this.appService.activityId.subscribe(value => {
      this.activityId = value;
    });
    this.dialerService.IsFreeDialer.subscribe(value => {
      this.isFreeDialer = value;
    });

    this.queueService.CaseDetails_ENABLECONTROLS.subscribe(val => {
      this.EnableDisableControls(val);
    });
      
    this.queueService.VoiceMailNav.subscribe(res => {
      this.IsVoiceMailNavigation = res;
      this.mainController.reset_dialogview();
      if (res) {
          this.showchangeusr();
        this.tmQueueService.getOptionsForQueue(this.queueService.getselectedQueueId()).subscribe(data => {
          if (data) {
            this.queueType = data.Response.Data.Type;
            this.appService.setSelectedQueueType(data.Response.Data.Type);
            //console.log(data.Response.Data.Type);
            if (data.Response.Data.Type === 'Inbound') {
              this.automatedQueue = true;
              //this.showhidebackbtn = false;
              this.mainController.setbackBtn(false);
            } else {
              // this.showhidebackbtn = true;
              this.mainController.setbackBtn(true);
            }
          }
        });
        this.VoiceMailDetails();
      }
    });

     
      this.tmQueueService.Transfer_SUBMIT_CALL
          .pipe(takeUntil(this.destroy$))
          .subscribe((value) => {

        if (value && this.mainController.getSaveChanges()) {
            try {
          console.log('Transfer Selected Userid', this.queueService.getselectedUserID());
          this.mainController.setSaveChanges(false);
          this.activityId = value.activityID;
          this.triggerType = value.triggerType;
          const paramArr = value.actionItem?.split('-');
          this.selectedCaseId = value ? paramArr[paramArr.length - 2] : paramArr[paramArr.length - 1];
          this.transferCaseID = value.transferCaseID;
            //commented due to value getting changed during transfer
          //this.selectedUserID = value.actionItem.includes('R')
          //  ? paramArr[paramArr.length - 3]
          //  : paramArr[paramArr.length - 2];
          this.isExternalTransfer = value.isExternalTransfer;
          this.queueType = value.queueType;
                if (this.dialerService.getIsFreeDialer()) {
                    //this.saveFreeDialerChanges();
                }
               /* else {*/
                if (this.triggerType == 'PreTransfer') this.saveChanges();
                else if (this.triggerType == 'PostTransfer') this.handleRedirection('');
                //}


          
          this.tmQueueService.setTransfer_SUBMIT_CALL(null); //setting value null to avoid repeatedly calling
        } catch (e) {
          console.log('Error in case detail transfer submit' + e);
        }
      }
    });
      this.tmQueueService.Trigger_saveChanges.subscribe(value => {
          if (value) {
              try {
                  //this.activityId = value.activityID;
                  //this.triggerType = value.triggerType;
                  //const paramArr = value.actionItem?.split('-');
                  //this.selectedCaseId = value ? paramArr[paramArr.length - 2] : paramArr[paramArr.length - 1];
                  //this.transferCaseID = value.transferCaseID;
                  //this.selectedUserID = value.actionItem.includes('R')
                  //    ? paramArr[paramArr.length - 3]
                  //    : paramArr[paramArr.length - 2];
                  //this.isExternalTransfer = value.isExternalTransfer;
                  //this.queueType = value.queueType;
                  //if (this.triggerType == 'PreTransfer')
                      this.saveChanges();
                  //else if (this.triggerType == 'PostTransfer') this.handleRedirection('');
                  this.tmQueueService.setTrigger_saveChanges(null); //setting value null to avoid repeatedly calling
              } catch (e) {
                  console.log('Error in case detail transfer submit' + e);
              }
          }
      });

    this.audio = new Audio();

    this.hubService.InboundCallEvents.subscribe((value: any) => {
      if (value && (value.eventName == 'OUTBOUND_CALL' || value.eventName == 'INBOUND_CALL') && this.mainController.getisCaseDetailStatus()) {
        console.log('outbound inbound call received', value.data);
        // _userDetails = value.data;
        this.eInboundCallHandler(value.data);
      }
    });
    this.TranscrtiptSubscribe();
  }

  TranscrtiptSubscribe() {
    this.appService.TranscriptEvents.subscribe((value: any) => {
      if (value != null) {
        this.TranscriptTabEnabled(value);
        if (value) {
          if (this.IsVoiceMailNavigation) {
            let defaultTab = this.rightPanelTabs.filter(tab => tab.label == 'Voicemail');
            this.rightPanelTabClick(defaultTab[0]);
          } else {
            let defaultTab = this.rightPanelTabs.filter(tab => tab.label == 'History');
            this.rightPanelTabClick(defaultTab[0]);
          }
        }
        //console.log('Event triggered  Transcrtipt Subscribe');
      }
    });
  }
    ngOnInit(): void {
      this.queueService.setReadOnlyCase(false);
      // Clear stale dirty-case flags from any previous call so they don't
      // bleed into this call's submit payload (inbound transfer scenario).
      this.appService.caseDirtyStateCache.clear();

      this.company = this.webStorageService.getItemFromSessionStorage('company');
        if(this.company == 'Baycare' || this.company == 'Parkland' || this.company == 'Antidote'){
          this.isClient_BCH_PCH_AHP = true;
      }

      this.dialerService.onHold.subscribe((val: boolean)=>{
        this.isCallOnHold = val;
      });
      this.dialerService.holdCallDuration.subscribe((value: string) =>{
        this.holdCallDuration = value;
      });
        this.appService.adjustTimer();
        this.mainController.setisCaseDetail(true);
        //Check if any call in-progress, then no need to update as pre-call status (5->on call, 7-> precall, 8-> postcall)
        if (this.getAgentStatus() != 5 && this.getAgentStatus() != 8) {
            this.appService.setUserStatus(7, this.queueService.getselectedQueueId());
            this.webStorageService.setItemInSessionStorage('previousUserStatus', 7)

        }
    this.headerService.answerInboundCall$.subscribe((value: any) => {
      if(value && this.mainController.getisCaseDetailStatus()){
        this.answerInboundNextCall();
        this.headerService.triggerAnswerInboundCall(null);
      }
    });

     this.headerService.rejectInboundCall$.subscribe((value: any) => {
       if(value && this.mainController.getisCaseDetailStatus()){
          this.rejectCall();
          this.headerService.triggerRejectInboundCall(null);
       }
    });

    let savedState = localStorage.getItem('rightPanelCollapsed');
    if (savedState) {
      this.isRightPanelCollapsed = savedState === 'true';
    }
    
    // Initialize disposition countdown timer
    //if(this.showDispositionCountdownTimer){
    //    this.startDispositionCountdownTimer();
    //}

    
    //keypad start
    this.dialpad = true;
    //keypad end
    //this.mainController.reset_dialogview();
    sessionStorage.setItem('ache', 'false');
    // this.mainController.setEnterRecord(null);
      this.mainController.resetValidationModal();
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key.endsWith('_conf')) {
        sessionStorage.removeItem(key);
        this.flexStore.remove(key);
      }
    }
    // if (this.getDialerType() === 'Keypad') {
    //   this.hideUserInformationTab = true;
    // }
    if (this.getDialerType() === 'Keypad') {
        this.mainController.setshowSearchDialog(true);
      this.queueService.hideUserInfoTab(); //
    } else {
        this.mainController.setshowSearchDialog(false);
      this.queueService.showUserInfoTab(); //
      }

      
    // this.queueService.showUserInfoTab$.subscribe(show => {
    //   this.hideUserInformationTab = !show;
    // });
    this.queueService.showUserInfoTab$.subscribe(show => {
      this.hideUserInformationTab = !show;
    });
    this.queueService.changeUserLabel$.subscribe(() => {
      this.setNewUserToChange();
    });
    this.queueService.elsePartVisible$.subscribe(visible => (this.showElsePart = visible));

    this.queueService.toggleUserLabel$.subscribe(() => {
      this.toggleNewUser();
    });

    //keypad start
    this.dialpad = true;
    //keypad end
    //this.mainController.reset_dialogview();//not required
    sessionStorage.setItem('ache', 'false');
    // this.mainController.setEnterRecord(null);
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key.endsWith('_conf')) {
        sessionStorage.removeItem(key);
        this.flexStore.remove(key);
      }
    }

    this.user = this.webStorageService.getItemFromSessionStorage('currentUser');

    if (!this.appService.getDispositionPayload()?.DispositionType) {
      this.formDataValid = false;
    }
      this.appService.selectedQueueType.subscribe((type: any) => {
          if (
              (type == 'Outbound' ||
                  type == 'Search' ||
                  type == 'Inbound' ||
                  type == 'Blended' ||
                  this.IsVoiceMailNavigation) && this.mainController.getisCaseDetailStatus()
          ) {
              // commnedted for voicemail inbound queue
              this.IsEnableCall = true;
              //if (!this.tmQueueService.getisCallConnected())
              

          }
          this.queueType = type;
          if (this.queueType === 'Inbound') {
              this.automatedQueue = true;
          }
          if (this.queueType === 'Search') {
              this.mainController.setbackBtn(true);
          }
      });

    try {
      this.clientAbbreviation = Utils.fetch('clientAbbreviation');
      const sub1 = this.appService.actionItemId.subscribe(value => {
        if (value) {
         // console.log('value', value);
          this.setUserDetails(value);
          this.loadConfiguration();
        }
      });
      this.subs.push(sub1);
    } catch (ex) {
      console.log('Error in case detail', ex);
    }

    this.route.params.subscribe((params: any) => {});

    this.callOptions = [
      { id: 1, label: 'Mobile' },
      { id: 2, label: 'Business' },
    ];
    this.selectedCallOption = this.callOptions[0];
   
    // this.queueService.getDialSections(this.activityId).subscribe(data => {
    //   this.menu = data;

    //   this.menu.Response.Data.forEach((ele, i) => {
    //     ele.isSelected = false;
    //   });
    // });

    // console.log(this.menuList);

    // // this.menuList=this.menu.Response.Data;
    // this.menuList[0].isSelected = true;

    // this.showData = {
    //   FullName: this.data.FullName,
    //   Id: this.data.CrmUserID,
    //   City: this.data.City,
    //   PhoneNumber: this.data.PhoneNumbers[0].Number,
    //   Designation: '',
    //   Supervisor: '',
    //   SupervisorPhoneNumber: '',
    // };

    // for (const field of this.data.UserInfoResponses) {
    //   if (field.FieldName == 'Designation') this.showData.Designation = field.Values[0];
    //   if (field.FieldName == 'Reporting Manager First Name') this.showData.Supervisor = field.Values[0];
    //   if (field.FieldName == 'Reporting Manager Contact Number') this.showData.SupervisorPhoneNumber = field.Values[0];
    // }

    this.queueService.DisableControls.subscribe(res => {
      this.IsDisableHeader = res;
      if (res) {
        this.IsDisableStartCall = res;
      }
    });
    const state = window.history.state;
    state.navigate = state?.activeRightPanelTabfromRow ? true : false;
    if (state?.activeRightPanelTabfromRow) {
      this.activeRightPanelTab == 1;
      this.activeRightPanelTab = false;
      this.rightPanelTabs = this.rightPanelTabs.filter(tab => tab.label !== 'Voicemail');
      this.rightPanelTabClick(this.rightPanelTabs[0]);
      //this.onPageChange({ first: this.first, rows: this.rows });
    }

    // this.queueService.currentQueue.subscribe((data: any) => {
    //   this.SelectedQueueName = data;
    // });

    // this.queueService.SetVoicemailDetailsReply((data: any) => {
    //   this.currentQueueData = data;
    // });
    //this.queueService.SetVoicemailDetailsReply
    this.appService.selectedQueueType.subscribe((type: any) => {
      if (!this.queueService.GetVoicemailDetailsReply() && (type == 'Outbound' || type == 'Inbound')) {
        //if (this.tmQueueService.getisCallConnected() || !this.tmQueueService.getisCallConnected()) {
        this.activeRightPanelTab == 1;
        this.activeRightPanelTab = false;
        this.rightPanelTabs = this.rightPanelTabs.filter(tab => tab.label !== 'Voicemail');
        this.rightPanelTabClick(this.rightPanelTabs[0]);
        //}
      }
    });

    this.queueService.voiceMailOnSearchContinue.subscribe((data: any) => {
      if (data && this.queueType == 'Search') {
        this.activeRightPanelTab == 1;
        this.activeRightPanelTab = false;
        this.rightPanelTabs = this.rightPanelTabs.filter(tab => tab.label !== 'Voicemail');
        this.rightPanelTabClick(this.rightPanelTabs[0]);
      }
    });

    //this.cdr.detectChanges();
    // this.dialerService.isOutboundCallStarted.subscribe((res)=>{
    //   this.isCallStarted=res?.['isOutboundCallConnected'];
    //   console.log("OutboundCallStarted:",res)
    // })
    this.cdr.detectChanges();
    if (this.getAgentStatus() == 7) {
      //7->precall
      //initializing softphone to receive calls. 
      if(!this.notesHelper.isEmptyOrWhitespace(this.queueService.getselectedQueueId())){
        console.log(this.queueService.getselectedQueueId(),'Qid');
        this.setQueueInfoforSoftphoneinitialization(this.queueService.getselectedQueueId());
      }
      }
      /*post call -> 8 , oncall-> 5*/
      //if (this.queueService.getFromSearchQueue() && (this.getAgentStatus() == 5 || this.getAgentStatus() == 8 )) {
      //   // this.mainController.buildQueueDetails(this.queueService.getselectedQueueId());
      //    this.callMaincontrollerQueueDetails(this.queueService.getselectedQueueId());
      //}
    if (this.getDialerType() == 'Keypad') {
      this.contactNumList = this.mainController.getQueueInfoDetail()?.ExternalNumbers;
    }
    //Transcript
    //this.appService.TransriptTab.subscribe((value: any) => {

    //    if (!value) {
    //        this.TranscriptTabEnabled(value);
    //    } else {
    //        this.TranscriptTabEnabled(value);
    //        let defaultTab= this.rightPanelTabs.filter(tab => tab.label == 'History');
    //        this.rightPanelTabClick(defaultTab[0]);
    //        //this.mainController.TranscriptReset();
    //    }
    //});

      if (this.getAgentStatus() == 8) {
          this.mainController.checkPostCallTimeout(false, false);
      }
      this.showchangeusr();
      if (this.queueType === 'Search'){
        let isReadOnlyMode = this.queueService.GetUnsubmittedCaseForReadonly();
        if(isReadOnlyMode){
          this.isButtonsReadOnlyMode = isReadOnlyMode;
          this.queueService.setReadOnlyCase(isReadOnlyMode);
        }
      }
  }

    clearDestroy() {
        try {
            this.destroy$.next();
            this.destroy$.complete();
        }
        catch (e) {}
    }

    showchangeusr() {
        let isTransferCall = this.getRequestType()?.split('|')[0] == 'Transfer' ? true : false;
        if (!isTransferCall) {
            if ((this.queueType === 'Inbound' || this.queueService.getVoicemailDetailsReplyForChangeUser()) && !this.mainController.getIsCaseUserUnmapped()) {//|| (this.mainController.getIsCaseUserUnmapped() && this.selectedUserID != 0)
                this.showChangeUser = true;
            }
        }
    }

  VoiceMailDetails() {
    let voicemailData = this.queueService.GetVoicemailDetails();
    if (voicemailData) {
      this.IsVoicemailNav = true;
      // Clear any transcript from a previous call so it does not bleed into
      // the voicemail reply transcript tab for the next user record.
      this.mainController.TranscriptReset();
      //console.log('AudioRes:', voicemailData);
      this.displayVoiceMailDetails = [
        { id: 1, label: 'User', value: voicemailData?.User ? voicemailData.User : '-' },
        { id: 1, label: 'Company', value: voicemailData?.Company ? voicemailData.Company : '-' },
        { id: 1, label: 'Request Type', value: voicemailData?.RequestType ? voicemailData.RequestType : '-' },
        { id: 1, label: 'Caller Number', value: voicemailData?.CallerNumber ? voicemailData.CallerNumber : '-' },
        {
          id: 1,
          label: 'Inbound Number',
          value: voicemailData?.InboundPhoneNumber ? voicemailData.InboundPhoneNumber : '-',
        },
        // { id: 1, label: 'Reviewed', value: voicemailData?.Reviewed ? voicemailData.Reviewed : '-' },
        // { id: 1, label: 'Responded', value: voicemailData?.Responded ? voicemailData.Responded : '-' },
           { id: 1, label: 'Reviewed', value: voicemailData?.Reviewed ? this.utils.GetESTtoLocalTimeZone(voicemailData.Reviewed) : '-', },
           { id: 1, label: 'Responded', value: voicemailData?.Responded ? this.utils.GetESTtoLocalTimeZone(voicemailData.Responded) : '-', },
      ];
      this.recordingDetails = null;
      this.isRecordLoaded = false;
      this.rightPanelTabs.forEach(tab => {
        if ('isSelected' in tab) {
          tab.isSelected = false;
        }
      });
      let temp = this.rightPanelTabs.filter(tab => tab.label == 'Voicemail');
      if (temp && temp.length <= 0) {
        this.rightPanelTabs.unshift({ id: 0, label: 'Voicemail', isSelected: true });
      } else if (temp && temp.length > 0) {
        this.rightPanelTabs.forEach(tab => {
          if (tab.id == 0) {
            tab.isSelected = true;
          }
        });
      }
      this.activeRightPanelTab = 0;
      this.getVoicemailTranscript(voicemailData.InteractionID);
      this.loadVoicemailAudio(voicemailData?.URL);
      //this.queueService.SetVoicemailDetails(null);
    }
  }
  SetCurrentActionItem(ActionItemID) {
    this.tmQueueService.setCurrentActionItem(this.queueService.getselectedQueueId(), ActionItemID).subscribe(data => {
      this.currentActionItemConfData = data;
      let EnableAICaseNotesTemplate = data.Response.Data?.EnableAICaseNotesTemplate || false;
      this.appService.setEnableAICaseNotesTemplate(EnableAICaseNotesTemplate);
      // this.appService.setEnableTemplateButton(EnableAICaseNotesTemplate);
      if (this.getAgentStatus() == 7) {
        this.mainController.setEnterRecord(data?.Response?.Data?.EnterRecord);
      }
        
        //if (this.queueService.getFromSearchQueue() && (this.getAgentStatus() == 5 || this.getAgentStatus() == 8)) {
        //    // this.mainController.buildQueueDetails(this.queueService.getselectedQueueId());
        //   // this.callMaincontrollerQueueDetails(this.queueService.getselectedQueueId());
        //    this.mainController.setItemsforSalesforce(data);
        //}
    });
  }

    showSubmitPause() {
        let dailerTypes = ['Preview', 'Power', 'Progressive', 'Predictive', 'AutomatedInbound', 'Keypad'];
        //if (this.currentActionItemConfData?.Response?.Data) {
        //    let queueDailerType = this.currentActionItemConfData?.Response?.Data?.DialerType;
        //    if (dailerTypes.includes(queueDailerType)) {
        //        return true;
        //    }
        //}
        var currentQueueDialerType = this.mainController.getDialerType();
        if (currentQueueDialerType) {
            let queueDailerType = currentQueueDialerType;
            if (dailerTypes.includes(queueDailerType)) {
                return true;
            }
        }

        return false;
    }
  ngAfterViewInit() {
    //console.log('Children:', this.children);
  }

  setUserInfo() {
    if (this.searchedUserData != null) {
      const userName = this.searchedUserData.FullName;
      const location = this.searchedUserData.State
        ? this.searchedUserData.State
        : '' + ',' + this.searchedUserData.Country
          ? this.searchedUserData.Country
          : '';
      let managerFirstName = '';
      let managerLastName = '';
      let designation = '';
      let managerContactNumber = '';
      let userContactNumber = '';
      if (this.searchedUserData.UserInfoResponses != null && this.searchedUserData.UserInfoResponses.length > 0) {
        this.searchedUserData.UserInfoResponses.forEach((obj: any) => {
          if (obj.FieldName == 'Designation') designation = obj.Values[0];
          else if (obj.FieldName == 'ManagerFirstName') managerFirstName = obj.Values[0];
          else if (obj.FieldName == 'ManagerLastName') managerLastName = obj.Values[0];
          else if (obj.FieldName == 'ManagerContactNumber') managerContactNumber = obj.Values[0];
        });
      }
      if (this.searchedUserData.PhoneNumbers != null && this.searchedUserData.PhoneNumbers.length > 0) {
        this.searchedUserData.PhoneNumbers.forEach((obj: any) => {
         // console.log(obj);
          // if(obj.Type=="Personal")
          //     userContactNumber=obj.Number;
          userContactNumber = obj.Number;
        });
      }
      this.userInfo = {
        UserName: userName,
        Designation: designation,
        ContactNumber: userContactNumber,
        ManagerName: managerFirstName ? managerFirstName : '' + ' ' + managerLastName ? managerLastName : '',
        ManagerContactNumber: managerContactNumber,
        Location: location,
      };
      this.chatbotService.setChatTitle(userName);
    }
  }

  clearUserInfo() {

        if (this.userInfo) {
            // clear all values for new user
            this.userInfo = {
                UserName: '',
                Designation: '',
                ContactNumber: '',
                ManagerName: '',
                ManagerContactNumber: '',
                Location: '',
            };
            this.chatbotService.setChatTitle('');
        }

  }

  get isCasesTabActive(): boolean {
      const casesTabValue = sessionStorage.getItem('_casesTabValue') || 'cases';
      return this.selectedTab === casesTabValue;
  }

  openAISuggestion(): void {
      this.chatbotService.openTab('ai-suggestion');
  }

  makeCall(phoneNo) {
    this.showDialer = true;
    //GET Twilio Token & Setup Twilio.Device
    this.tmQueueService.GetTwilioToken().subscribe((response: any) => {
      console.log('Twilio Token', response.Response.Data.Token);

      const token = response.Response.Data.Token;

      const deviceOptions = {
        codecPreferences: ['opus', 'pcmu'],
        fakeLocalDTMF: true,
        enableRingingState: true,
        debug: true,
        edge: ['ashburn'],
      };

      this.device = new Twilio.Device(token, deviceOptions);

      this.device.on('ready', device => {
        console.log('Twilio.Device Ready!');
        const params = { To: phoneNo, debug: true };
        console.log('Calling ' + params.To + '...');

        const call = this.device.connect(params);

        call.on('ringing', function (conn) {
          console.log('Ringing...');
        });

        call.on('disconnect', conn => {
          console.log('Disconnected...');
          this.endCall();
        });

        call.on('error', error => {
          console.log('Call Error:', error);
        });
      });

      this.device.on('error', error => {
        console.log('Twilio.Device Error: ' + error.message);
        this.showDialer = false;
      });
    });

    //   this.device.on(Twilio.Device.EventName.TokenWillExpire, async () => {
    //     this.queueService.GetTwilioToken().subscribe((response:any) =>{
    //       this.device.updateToken(response.Response.Data.Token)
    //     });
    //   });
  }

  endCall() {
    //Twilio.Device.disconnectAll();
    //Twilio.Device.destroy();
    this.device.disconnectAll();
    this.device.destroy();
    this.showDialer = false;
  }
  EnableDisableControls(val) {
    this.disableSubmitButton = val;
  }
  muteMic() {
    //Twilio.Device.activeConnection().getRemoteStream().getAudioTracks()[0].enabled = !Twilio.Device.activeConnection().getRemoteStream().getAudioTracks()[0].enabled;
    //console.log("muteMic", Twilio.Device.activeConnection().getRemoteStream().getAudioTracks()[0].enabled);
    (this.device.activeConnection().getRemoteStream().getAudioTracks()[0].enabled = !this),
      this.device.activeConnection().getRemoteStream().getAudioTracks()[0].enabled;
    console.log('muteMic', this.device.activeConnection().getRemoteStream().getAudioTracks()[0].enabled);
  }

  receiveCall() {
    this.tmQueueService.GetTwilioToken().subscribe((response: any) => {
      console.log('Twilio Token', response.Response.Data.Token);

      const device = new Twilio.Device(response.Response.Data.Token, {
        codecPreferences: ['opus', 'pcmu'],
        fakeLocalDTMF: true,
        enableRingingState: true,
        debug: true,
      });

      device.on('incoming', function (conn) {
       // console.log(conn.parameters);
        console.log('Incoming connection from ' + conn.parameters.From);
        $('#callerNumber').text(conn.parameters.From);
        $('#txtPhoneNumber').text(conn.parameters.From);

        //$('#modal-incomming-call').modal('show')

        $('.btnReject').bind('click', function () {
          //$('.modal').modal('hide')
          console.log('Rejected call ...');
          conn.reject();
        });

        $('.btnAcceptCall').bind('click', function () {
          //$('.modal').modal('hide')
          console.log('Accepted call ...');
          conn.accept();
        });
      });
    });
  }

  //let params = { "To": "+919902897172", "IsRecord":true};
  //let connection = Twilio.Device.connect(params);

  //   connection.on("ready", function (conn) {
  //     console.log("Twilio.Device Ready!");
  //   });

  //   connection.on("ringing", function (conn) {
  //     console.log("Ringing...");
  //   });

  //   connection.on("disconnect", function (conn) {
  //     console.log("Call ended.");
  //   });

  //   connection.on("connect", function (conn) {
  //     console.log('Successfully established call ! ');
  // });

  selectLink(index) {
    this.menuList[index].isSelected = true;
    this.menuList.forEach((ele, i) => {
      if (i == index) ele.isSelected = true;
      else ele.isSelected = false;
    });
   // console.log(this.menu);
  }

  menuSelected(value) {
    this.selectedSubmenu = '';
    this.selectedTab = value;
   // console.log('this.selectedTab', this.selectedTab);
    this.menuList.forEach((ele, i) => {
      if (ele.value === value) ele.isSelected = true;
      else ele.isSelected = false;
    });

    //display submenu
    const tempLst = this.subMenuList.filter(menu => menu['MenuName'] == value);
    if (tempLst && tempLst.length > 0) {
      this.subMenulstSelected = tempLst[0]['SubMenu'];
      this.subMenulstSelected.forEach(submenu => {
        submenu.IsSelected = false;
      });
      this.subMenulstSelected[0].IsSelected = true;
      this.selectedSubmenu = this.subMenulstSelected[0].Name;
    } else {
      this.subMenulstSelected = [];
      this.selectedSubmenu = '';
    }
  }

  changeUserStatus(event: any) {
    console.log(event);
    this.status = event;
  }

  onSubmit(submitType: any = '') {
    if (this.isSubmittingCaseDetails) {
      // A submit request is already in progress.
      return;
    }
    let companyName = this.webStorageService.getItemFromSessionStorage('company');
    this.toggleSubmitDropdown(null);
    this.getAllDynamicFormData();
      this.mainController.resetPostCallTimeout();
    this.invalidFields = [];
    let casesTabValue = sessionStorage.getItem('_casesTabValue') || 'cases';

    //Validate all tabs data. We should validate cases separately.
    //console.log('this.caseDetailsConf', this.caseDetailsConf);
    this.caseDetailsConf.Tabs.forEach(tab => {
      if (tab.TabValue != casesTabValue) {
        // don't validate cases here
        if (tab.hasError) {
          tab.Groups.forEach(group => {
            group.Fields.forEach(field => {
              if (field.invalid && field.show) {
                this.invalidFields.push({ tab: tab.TabName, group: group.GroupName, field: field });
              }
            });
          });
        }
      }
    });

      var fieldsReadOnly = this.caseDetailsConf?.Tabs[0]?.Groups[0]?.Fields.find(item => item.Name === 'ReadOnly');
      var isreadonly = false;
      if (fieldsReadOnly)
          if (fieldsReadOnly.value.toLowerCase() == 'true') {
              isreadonly = true;
          }

      var usertypedetails = this.caseDetailsConf?.Tabs[0]?.Groups[0]?.Fields.find(item => item.Name === 'Role');
      if (usertypedetails) {
          if (usertypedetails.value == '' && !isreadonly) {
              this.invalidFields.push({ tab: this.caseDetailsConf?.Tabs[0].TabName, group: this.caseDetailsConf?.Tabs[0]?.Groups[0].GroupName, field: { Name: 'UserType' } });
          }
      }

    // Validate cases
    this.invalidCaseFields = [];
    if (sessionStorage.getItem('ache') == 'true') {
      //console.log('Some cases has invalid field.');
      //let cachedData = JSON.parse(sessionStorage.getItem(casesTabValue + '_conf'));
      let cachedData = JSON.parse(this.flexStore.get(casesTabValue + '_conf'));
      let casesVerify = this.appService.getEditedCases();
      cachedData.forEach(item => {
        let isPresent = casesVerify?.filter(c => c.CaseID.toString() === item?.caseId);
        if(isPresent?.length > 0){
          if (item.conf.hasError && item.caseId) {
          item.conf.Groups.forEach(group => {
            let statusID = '';
            group.Fields.forEach(field => {
              if(field.Name == "CaseStatusID"){
                statusID = field.value;
              }
              if (field.invalid) {
                let index = this.invalidCaseFields.findIndex(
                  errItem => errItem.fieldName === field.Name && errItem.caseId === item.caseId
                );
                if (index == -1) {
                  // don't exist
                  
                      const isValid =
                            field?.Name === 'CaseAssigner' &&
                            field?.isRequired &&
                            statusID === '2' &&
                            this.isClient_BCH_PCH_AHP;

                  if(!isValid){
                    this.invalidCaseFields.push({ fieldName: field.Name, caseId: item.caseId });
                  }
                }
              }
            });
          });
          }
        }
      });
    }

    console.log('invalidFields', this.invalidFields);
    console.log('invalidCaseFields', this.invalidCaseFields);

    if (this.invalidFields.length > 0 || this.invalidCaseFields.length > 0) {
      this.openModal();
      return;
    }

    let enterRecorddet: any;
    try {
      if (this.mainController.getEnterRecord() != '') {
        enterRecorddet = new Date(this.mainController.getEnterRecord()).getTime();
      }
      //enterRecorddet= (this.mainController.getEnterRecord() != '') ? this.mainController.getEnterRecord().getTime() : ''
    } catch (e) {}
    const voicemailDetails  = this.queueService.GetVoicemailDetails?.();
    const isVoicemailReply  = this.IsVoiceMailNavigation || this.queueService.getVoicemailDetailsReplyForChangeUser?.() === true;
    const voicemailIDToSend  = isVoicemailReply  ? (voicemailDetails?.ID ?? voicemailDetails?.VoicemailID ?? null) : null
    const pl = {
      calleeUserId: this.appService.getIsAddNewUser() ? "-1" : this.selectedUserID,
      activityId: this.activityId,
      queueId: this.queueService.getselectedQueueId(),
      //interactionID:'',
      callID: this.queueService.getCallID()?.trim() || this.queueService.getChildCallID()?.trim() || '',
      notes: '',
      callDuration: this.dialerService.getCallDuration(),
      enterRecord: enterRecorddet,
      customTYLanguage: null,
      scheduledInteractionID: null,
      voicemailID: voicemailIDToSend,
      requestType: null,
      requestTypeColor: null,
      visiblefielddata: [],
      appointmentData: null,
      company: companyName
    };
    const pl2 = {
        interactionID: this.queueService.getCallID()?.trim() ? this.queueService.getInteractionID() : '',
    };

    if (
      this.dialerService.getIsEnableAddNewNumber() &&
      this.dialerService.getIsSaveUserRecord() &&
      (this.dialerService.getCallDisconnected() || this.dialerService.getCallStatus() == 'Ringing')
    ) {
      if (
        this.allDynamicTabsData.userInformation != null &&
        this.allDynamicTabsData.userInformation.PhoneNumbers != null
      ) {
        this.addDialedNumber();
      }
    }
    let payload = { ...pl, ...this.allDynamicTabsData };
    if (this.dialerService.getIsCaseDetailFreeDial()) {
      pl.callID = '';
      payload = { ...payload, ...pl2 };
    }
    //payload.isAddNewUser = this.appService.getIsAddNewUser();
    payload.cases = this.appService.getEditedCases();

    // -----------------
    // Only submit cases that were actually modified by the agent or are newly created in
    // this session. Without this filter, every case the agent navigates to gets added to
    // editedCases and sent on submit, causing Last Modified to be updated with no real changes.

    const dirtyCache = this.appService.caseDirtyStateCache;

    // Build a string-keyed dirty set from the Map
    const dirtyCaseIdStrings = new Set<string>();
    dirtyCache.forEach((_, k) => dirtyCaseIdStrings.add(String(k)));
    const newCaseIdStrings = new Set<string>([
      ...(this.newUserCases ?? []).map((c: any) => String(c.CaseID)),
      ...(JSON.parse(this.flexStore.get('NewUserCases')) ?? []).map(String),
    ]);

    if (dirtyCaseIdStrings.size > 0 || newCaseIdStrings.size > 0) {
      payload.cases = (payload.cases ?? []).filter((c: any) => {
        const id = String(c.CaseID);
        return dirtyCaseIdStrings.has(id) || newCaseIdStrings.has(id);
      });
    } else {
      // No dirty cases and no new cases — nothing to save
      payload.cases = [];
    }
    //----------------

    let findMemberId = this.appService.getLookUpMemberId();
    if (findMemberId?.length > 0) {
      payload.cases?.forEach(item => {
        const fieldAttr = Object.keys(item);
        fieldAttr?.forEach(field => {
          let index = findMemberId.findIndex(fmItem => fmItem.caseId == item.CaseID && fmItem.fieldName == field);
          if (index !== -1) {
            item[field] = findMemberId[index].findMemberId;
          }
        });
      });
    }

    //Different user created case, assigning UserId
    const loginParams = this.webStorageService.getItemFromSessionStorage('loginParams');
    if(loginParams){
      let allowDifferentUserCase = (loginParams?.AllowDifferentUserCase?.toLowerCase() === 'true'); 
      let otherUserCases = JSON.parse(this.flexStore.get('CaseCreatedForDifferentUser'));
      let otherUserCasesForTransfers = JSON.parse(this.flexStore.get('DifferentUserCasesForTransfers'));
      if(allowDifferentUserCase){
        if(otherUserCases){
          otherUserCases?.forEach(u => {
            payload?.cases?.forEach(c => {
              if(u && u.CaseID && u.CaseID.map(String).includes(c.CaseID)){  
                c.OtherUserID = u.UserID;
              }
            });
          });
        }

        if(otherUserCasesForTransfers){
          otherUserCasesForTransfers?.forEach(u => {
            payload?.cases?.forEach(c => {
              if(u && u.CaseID && u.CaseID.map(String).includes(c.CaseID)){  
                c.OtherUserID = u.UserID;
              }
            });
          });
        }
      }
    }
      

    //Date Time Picker Data
    let dateTimePickerData = this.appService.getDateTimePickerData();
    dateTimePickerData?.forEach(item => {
      switch (item.tabName) {
        case 'cases':
          payload.cases.forEach((caseItem, index) => {
            if (caseItem.CaseID == item.caseId) {
              payload.cases[index][item.fieldName] = item.convertedDateValue;
            }
          });
          break;
        case 'userInformation':
          payload.userInformation[item.fieldName] = item.convertedDateValue;
          break;
        case 'disposition':
          switch (item.fieldName) {
            case 'UserFollowupDateTime':
              payload.disposition['FollowUpDateTime'] = item.convertedDateValue;
              break;
            case 'CallerFollowupDateTime':
              payload.disposition['FollowUpDateTime'] = item.convertedDateValue;
              break;
          }
          break;
      }
    });
    //Document Data
    let documentData = this.appService.getDocumentData();
    payload.cases.forEach(item => {
      let documentIndex = documentData.findIndex(ndItem => ndItem.caseId == item.CaseID);
      if (documentIndex !== -1) {
        let oldDocJSONStr = documentData[documentIndex].oldValue;
        let newDocJSONStr = JSON.stringify(item.Documents);
        if (oldDocJSONStr === newDocJSONStr) delete item.Documents;
      }
    });
    // Notes Data
    this.getCaseNotes(payload);
    // let notesData = this.appService.getNotesData();
    // payload.cases.forEach(item => {
    //   let notesindex = notesData.findIndex(ndItem => ndItem.caseId == item.CaseID);
    //   if (notesindex !== -1) {
    //     console.log(item);
    //     console.log(notesData);
    //     var currentdate = new Date();
    //     var date = this.utils.formatDate(currentdate);
    //     var time = this.utils.formatTimeWithSeconds(currentdate, 0);

    //     let notesHtmlPayload = '';
    //     let notesItem = '';

    //     //no value
    //     if (item.Notes == '' && notesData[notesindex].oldValue == '') {
    //       notesHtmlPayload = ''; // no notes
    //     }

    //     //new value
    //     if (item.Notes != '' && notesData[notesindex].oldValue == '') {
    //       notesHtmlPayload =
    //         '<span class="Noteshistory">' +
    //         this.user?.FirstName +
    //         ' ' +
    //         this.user?.LastName +
    //         ',' +
    //         time +
    //         ',' +
    //         date +
    //         '<span><br/>';
    //       notesItem = '<span class="NotesPre">' + item.Notes + '</span><br/>';
    //       notesHtmlPayload = notesHtmlPayload + notesItem; //new note
    //     }
    //     //old value
    //     if (
    //       item.Notes != '' &&
    //       item.Notes?.includes('Noteshistory') &&
    //       notesData[notesindex].oldValue != '' &&
    //       notesData[notesindex].oldValue?.includes('Noteshistory')
    //     ) {
    //       notesHtmlPayload = notesData[notesindex].oldEncodedValue; //old note
    //     }

    //     //old value + new value
    //     if (
    //       item.Notes != '' &&
    //       !item.Notes?.includes('Noteshistory') &&
    //       notesData[notesindex].oldValue != '' &&
    //       notesData[notesindex].oldValue?.includes('Noteshistory')
    //     ) {
    //       notesHtmlPayload =
    //         '<span class="Noteshistory">' +
    //         this.user?.FirstName +
    //         ' ' +
    //         this.user?.LastName +
    //         ',' +
    //         time +
    //         ',' +
    //         date +
    //         '<span><br/>';
    //       notesItem = '<span class="NotesPre">' + item.Notes + '</span><br/>';
    //       notesHtmlPayload = notesData[notesindex].oldValue + notesHtmlPayload + notesItem; //new note
    //     }

    //     item.Notes = notesHtmlPayload; //final data for notes
    //   }
    // });

    // let notesData = this.appService.getNotesData();

    // payload.cases.forEach(item => {
    //   let index = notesData?.findIndex(ndItem => ndItem.CaseID == item.CaseID);
    //   if (index !== -1) {
    //   var currentdate = new Date();

    //   var date = this.utils.formatDate(currentdate);
    //   var time = this.formatTime(currentdate, 0);

    //   // let notesHtmlPayload ='<span class="Noteshistory">' + this.user?.FirstName +' ' +this.user?.LastName +
    //   //   ',' + time + ',' + date + '<span><br/>';
    //   let notesHtmlPayload ='';
    //   let notesItem = '';

    //     if ( notesData[0].oldvalue && notesData[0].oldvalue?.includes('Noteshistory')) {
    //       console.log(item);
    //       console.log(this.user, 'user details');
    //       notesHtmlPayload ='<span class="Noteshistory">' + this.user?.FirstName +' ' +this.user?.LastName +
    //       ',' + time + ',' + date + '<span><br/>';
    //       notesItem = '<span class="NotesPre">' + item.Notes + '</span><br/>';
    //       const doc = new DOMParser().parseFromString(notesData[0].oldvalue, 'text/html');
    //       let oldValue = doc.documentElement.textContent;
    //       // console.log(oldValue);
    //       notesHtmlPayload = notesData[0].oldValue + notesHtmlPayload + notesItem;

    //     } else if(item.Notes && !(notesData[0].oldvalue) && !(notesData[0].oldvalue?.includes('Noteshistory'))) {
    //       notesHtmlPayload ='<span class="Noteshistory">' + this.user?.FirstName +' ' +this.user?.LastName +
    //       ',' + time + ',' + date + '<span><br/>';
    //       notesItem = '<span class="NotesPre">' + item.Notes + '</span><br/>';
    //       notesHtmlPayload = notesHtmlPayload + notesItem;
    //     }

    //     item.Notes = notesHtmlPayload;

    //     // notesHtmlPayload = ''
    //   }
    // });

    payload.notes = this.appService.getDispositionNotes();

    console.log(payload);
    this.isSubmittingCaseDetails = true;
    this.managerService
      .submitCaseDetails(this.filterPayload(payload))
      .pipe(finalize(() => (this.isSubmittingCaseDetails = false)))
      .subscribe((res: any) => {
      console.log('submitCaseDetails res', res);
      this.appService.setIsCaseEdit(true);
        this.mainController.setEnterRecord(null);
        this.mainController.setUnmappedCaseID('');
        this.mainController.setUnmappedUserID('');
        this.queueService.setChildCallID('');
        this.mainController.setIsCaseUserUnmapped(null);
        this.mainController.setIsUnknownContact(false);
        this.queueService.SetVoicemailDetailsReply(false);
        this.mainController.setshowSearchDialog(false);
        this.clearDestroy();
      // success
      if (res.Response.Status === 1) {
        this.queueService.setSelectedNewUserId(null);
        this.appService.caseDirtyStateCache.clear();
        let isAddNewUser = this.appService.getIsAddNewUser();
        if ((this.selectedUserID == null || this.selectedUserID == '0') && (this.newUser == 'New User' || this.newUser == 'Change User') && isAddNewUser) {
            this.selectedUserID = res.Response?.Data?.UserID;
            this.queueService.setselectedUserID(this.selectedUserID);
        }
        if (submitType != 'followup') {
          this.queueService.setOtherUserCasesForCancelTransfer(null);
          this.queueService.setCallIDForTransferCases('');
          this.flexStore.remove('CaseCreatedForDifferentUser');
          this.flexStore.remove('DifferentUserCasesForTransfers');
          this.flexStore.remove('NewUserCases');
          this.queueService.setValueParentChk(true);
          this.queueService.setValueChildChk(false);
          this.mainController.TranscriptReset();
          this.queueService.SetUnsubmittedCaseForReadonly(false);
        }else if(submitType == 'followup'){
          this.flexStore.remove('NewUserCases');
          this.queueService.setCallIDForTransferCases(this.queueService.getCallID());
        }
        this.dialerService.setHoldCallDuration("0:00");
        this.dialerService.setPhoneNo('');
        this.dialerService.setResetCallSummary(true);
        this.queueService.SetDisableHeader(false);
        this.dialerService.setIsCaseDetailFreeDial(false);
        this.queueService.setisEscalatedCases(false);
        this.appService.setIsAddNewUser(false);
        this.appService.setEnableTemplateButton(false);
        this.mainController.saveVideoRecording(res.Response.Data.InteractionID);
        if (res.Response?.Data?.EscalatedCases.length > 0) {
          let escalatedCases = res.Response?.Data?.EscalatedCases;
          this.handleEscalatedCases(escalatedCases, submitType);
        } else {
          this.handleRedirection(submitType);
        }
        this.queueService.SetVoicemailDetailsReplyForChangeUser(false);
        this.resetNotesValue(payload,true);
      } else {
        // failure - 2  create a new record in search queue
        // const test = this.appService.getConfirmationStatus();
        // console.log(test);
        // if (false && this.appService.getConfirmationStatus()) {
        //   this.handleRedirection(submitType);
        // } else {
        // failure - 2
        this.resetNotesValue(payload,false);
        this.errorMessage = res.Response.Message;
        console.log('Error:', res.Response.Message);
        this.openModal();
        //}
      }
    });
    //let baseURL = this.configService.geturl(Utils.fetch('clientAbbreviation'));
    let baseURL = this.webStorageService.getItemFromSessionStorage('loginParams')?.ExternalAPIURL;
    if(baseURL){
      if(this.WindowsWrapper.IsWrapper() && this.isClient_BCH_PCH_AHP){
        baseURL = 'cr' + baseURL;
        this.WindowsWrapper.EnableCRProtocol(true);
      }
     // this.configService.OpenUrlInNewTab(baseURL);
    }
  }
  handleRedirection(submitType) {
    this.dialerComponent.OutBoundNumber='';
    this.queueService.SetDisableHeader(false);
    this.queueService.setCaseDetailsLoaded(false);
    this.dialerService.setCallDisconnected(false);
    this.mainController.setAllDialerWindowStatus(false, false, false);
    //this.tmQueueService.setisCallConnected(false);
    // this.dialerService.setIsCaseDetailFreeDial(false);
    this.IsVoiceMailNavigation = false;
    this.queueService.SetVoiceMailNav(false);
    this.queueService.setInteractionID('');
    this.queueService.currentInteractionID(null);
    if (this.getAgentStatus() != 5) {
      //5->oncall
      this.queueService.setCallID('');
    }
      if (submitType != '' && submitType == 'pause') {

          if (this.queueType == 'Inbound' && (this.getDialerType() == 'AutomatedInbound' || this.getDialerType() == 'Progressive')) {
              this.dialerService.setIsAgentStatusChangeRequired(true);
              this.queueService.setQueueRoute(
                  this.clientAbbreviation + '/Queue/' + this.queueType + '?qid=' + this.queueService.getselectedQueueId()
              );
              this.router.navigate([Utils.fetch('clientAbbreviation') + '/Queue/Inbound'], {
                  queryParams: { qid: this.queueService.getselectedQueueId() },
              });
              this.appService.setUserStatus(9, this.queueService.getselectedQueueId());
              this.tmQueueService.setshowdialerstatusmenu({ showstatusmenu: true });
          }
          else {
              if (this.dialerService.getIsStatusModalOpen()) {
                  return;
              }
              this.appService.setUserStatus(9, this.queueService.getselectedQueueId());
              this.dialerService.setIsAgentStatusChangeRequired(true);
              const initialState = {
                  ShowOkButton: false,
              };
              const config: ModalOptions = {
                  class: 'modal-sm',
                  initialState: initialState,
                  backdrop: 'static',
                  keyboard: false,
              };
              if (this.modalRef) {
                  this.modalRef.hide();
              }
              this.modalRef = this.modalService.show(CurrentStatusMessageComponent, config);
          }

      } else if (submitType != '' && submitType == 'followup') {
      this.getCaseDetailsConfig(
        this.activityId,
        this.selectedUserID,
        this.selectedCaseId,
        this.queueService.getselectedQueueId()
      );
      this.getCallHistoryDetails();
    } else {
      if (this.getDialerType() != 'Keypad') {
        this.queueService.notifyOtherFromTaskMenu({
          refresh: true,
          menuName: this.queueType,
        });
      }

      this.queueService.setTaskMenuQueueSelected({
        pageRefresh: true,
        isPageInitCompleted: false,
        queueType: this.queueType,
      });
      if (this.queueType == 'Inbound') {
        this.queueService.setQueueRoute(
          this.clientAbbreviation + '/Queue/' + this.queueType + '?qid=' + this.queueService.getselectedQueueId()
        );
        this.router.navigate([Utils.fetch('clientAbbreviation') + '/Queue/Inbound'], {
          queryParams: { qid: this.queueService.getselectedQueueId() },
        });
      } else if (this.queueType == 'Outbound' && this.getDialerType() != 'Keypad') {
        this.router.navigate([Utils.fetch('clientAbbreviation') + '/Queue/Outbound'], {
          queryParams: { qid: this.queueService.getselectedQueueId() },
        });
        this.appService.setUserStatus(6, this.queueService.getselectedQueueId());
      } else if (this.queueType == 'Outbound' && this.getDialerType() == 'Keypad') {
        this.appService.setActionItemId(this.queueService.getselectedQueueId() + '-' + null + '-' + null);
        //this.router.navigate([Utils.fetch('clientAbbreviation') + '/Queue/caseDetails'], {
        //    queryParams: { qid: this.queueService.getselectedQueueId() },
        //});
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          // this.router.navigate([this.clientAbbreviation + '/Queue/' + selectedQueue.type]);
          //this.router.navigate([this.clientAbbreviation + '/Queue/' + selectedQueue?.type], {
          //    queryParams: { qid: selectedQueue?.id },
          //});

          this.router.navigate([Utils.fetch('clientAbbreviation') + '/Queue/caseDetails'], {
            queryParams: { qid: this.queueService.getselectedQueueId() },
          });
        });
        this.appService.setUserStatus(7, this.queueService.getselectedQueueId());
        this.webStorageService.setItemInSessionStorage('previousUserStatus', 7);
      } else if (this.queueType == 'Search') {
        this.router.navigate([Utils.fetch('clientAbbreviation') + '/Queue/Search']);
        this.appService.setUserStatus(6, this.queueService.getselectedQueueId());
      }
    }
  }

  handleEscalatedCases(escalatedCases, submitType) {
    console.log(submitType);
    let queueID = escalatedCases[0].UserSegmentationID;
    let userID = escalatedCases[0].UserID;
    let caseID = escalatedCases[0].CaseID;
    let segmentationName = escalatedCases[0].SegmentationName;
    const initialState = {
      contentMsg:
        'Case ' +
        caseID +
        ' has been escalated to the queue "' +
        segmentationName +
        ' . Would you like to go there now?',
      cancelBtnValue: 'No',
      confirmBtnValue: 'Yes',
      isConfirm: true,
      isDelete: false,
    };
    this.tmQueueService.getOptionsForQueue(queueID).subscribe(data => {
      if (data) {
        // this.queueType = data.Response.Data.Type;
        this.escalatedQueueType = data.Response.Data.Type;
        //this.appService.setSelectedQueueType(data.Response.Data.Type);
       // console.log(data.Response.Data.Type);
      }
    });
    const config: ModalOptions = {
      class: 'confirm-dialog modal-wd-400',
      initialState,
    };
    this.modalRef = this.modalService.show(ConfirmDialogComponent, config);
    this.modalRef.content.event.subscribe(async (result: any) => {
      if (result.value == 'confirm') {
        this.modalRef.hide();
        let isFromSearchQueue = this.queueService.getFromSearchQueue();
       // console.log(isFromSearchQueue, 'search');
        if (isFromSearchQueue) {
          // this.router.navigate([Utils.fetch('clientAbbreviation') + '/Queue/caseDetails']);
          this.SelectedQueueName = 'Queue';
          this.tmQueueService.getOptionsForQueue(queueID).subscribe(data => {
            if (data) {
              this.escalatedQueueType = data.Response.Data.Type;
              this.queueService.notifyOtherFromTaskMenu({
                refresh: true,
                menuName: this.escalatedQueueType,
              });

              this.queueService.setTaskMenuQueueSelected({
                pageRefresh: false,
                isPageInitCompleted: false,
                queueType: this.escalatedQueueType,
              });

              this.queueType = this.escalatedQueueType;
              this.appService.setSelectedQueueType(this.escalatedQueueType);
              this.queueService.setselectedQueueId(queueID);
              this.queueService.setisEscalatedCases(true);
              this.setQueueDetails(queueID, userID, caseID);
              this.appService.setDispositionPayload(null);
              this.handleFormDataHasError(null, null);

              this.router.navigate([Utils.fetch('clientAbbreviation') + '/Queue/caseDetails']);
            }
          });
        } else {
          this.tmQueueService.getOptionsForQueue(queueID).subscribe(data => {
            if (data) {
              this.escalatedQueueType = data.Response.Data.Type;
              this.queueService.notifyOtherFromTaskMenu({
                refresh: true,
                menuName: this.escalatedQueueType,
              });

              this.queueService.setTaskMenuQueueSelected({
                pageRefresh: true,
                isPageInitCompleted: false,
                queueType: this.escalatedQueueType,
              });

              this.queueType = this.escalatedQueueType;
              this.appService.setSelectedQueueType(this.escalatedQueueType);
              this.queueService.setselectedQueueId(queueID);
              this.queueService.setisEscalatedCases(true);
              this.setQueueDetails(queueID, userID, caseID);
              this.appService.setDispositionPayload(null);
              this.handleFormDataHasError(null, null);
            }
          });
        }

       // console.log(isFromSearchQueue, 'search');

        //this.handleRedirection(submitType);
      } else {
        this.modalRef.hide();
        this.handleRedirection(submitType);
      }
    });
  }
  rightPanelTabClick(item: any) {
    this.rightPanelTabs.forEach(element => {
      element.isSelected = false;
    });
    item.isSelected = true;
    this.activeRightPanelTab = item.id;
  }
  setQueueDetails(queueID, userID, caseID) {
    this.tmQueueService.getQueues().subscribe(data => {
      let queues = data.Response.Data;
      queues.forEach(selectedQueue => {
        if (selectedQueue.ID == queueID) {
          this.queueService.setInteractionID('');
          this.queueService.currentInteractionID(null);
          this.queueService.setCallID('');
          this.appService.setselectedQueueId(selectedQueue.ID);
          this.appService.setSelectedQueueName(selectedQueue.Name);
          this.appService.setSelectedQueueType(selectedQueue.Type);
          this.mainController.setInteractionType(selectedQueue.Type);
          this.appService.setActivityId(selectedQueue.ActivityID);
          this.appService.setActionItemId(selectedQueue.ActivityID + '-' + userID + '-' + caseID);
          this.appService.setselectedQueueId(queueID);
          this.queueService.setselectedQueueId(queueID);
          this.queueService.SetTaskSelectedQueue({
            refresh: true,
            menuName: {
              queue: selectedQueue,
            },
          });

          this.router.navigate([Utils.fetch('clientAbbreviation') + '/Queue/caseDetails']);
          let isFromSearchQueue = this.queueService.getFromSearchQueue();
         // console.log(isFromSearchQueue, 'search');
          if (isFromSearchQueue) {
            this.SelectedQueueName = 'Queue';
          }
        }
      });
    });
  }
  

  onPageChange(event: PaginatorState): void {

    const first = event.first ?? 0;
    const rows = event.rows ?? 10;
  
    this.first = first;
    this.rows = rows;
  
    const newPage = Math.floor(first / rows) + 1;
  
    if (this.isCaseHistorySearchActive && this.callHistorySearchTerm) {
  
      const filterDict = [
        {
          Key: 'CaseId',
          Value: [this.callHistorySearchTerm]
        }
      ];
  
      this.queueService
        .getCallHistory(
          this.selectedUserID,
          newPage,
          this.queueService.getCallID(),
          filterDict
        )
        .subscribe({
          next: (res: any) => {
  
            const data = res?.Response?.Data;
            const records = data?.ItemsList?.[0] || [];
            records.forEach((item: any) => {
              item.custTtype =
                item.NumberCalled &&
                item.Type?.toLowerCase() !== 'nointeraction'
                  ? 'Call'
                  : 'No Interaction';
            });
            
            this.paginatedData = records;
            this.TotalItemCount = data?.TotalItemCount || 0;
          }
        });
  
    } else {
  
      this.getCallHistoryDetails(newPage);
  
    }
  }



  // get filteredCallHistory(): any[] {
  //   if (!this.paginatedData) return [];
  //   const term = (this.callHistorySearchTerm ?? '').trim().toLowerCase();
  //   if (!term) return this.paginatedData;
  //   return this.paginatedData.filter((item: any) => {
  //     return (
  //       String(item.CaseID ?? '').toLowerCase().includes(term) ||
  //       String(item.ID ?? '').toLowerCase().includes(term) ||
  //       String(item.Caller ?? '').toLowerCase().includes(term) ||
  //       String(item.Disposition ?? '').toLowerCase().includes(term) ||
  //       String(item.NumberCalled ?? '').toLowerCase().includes(term)
  //     );
  //   });
  // }

  get filteredCallHistory(): any[] 
  {
    return this.paginatedData || [];
  }
  get paginatorTotalRecords(): number 
  {
    return this.TotalItemCount;
  }
  // get paginatorTotalRecords(): number {
  //   const term = (this.callHistorySearchTerm ?? '').trim();
  //   return term ? this.filteredCallHistory.length : this.TotalItemCount;
  // }
  // onPageChange(event: any) {
  //   this.first = event.first;
  //   this.rows = event.rows;
  //   const callHistory = JSON.parse(JSON.stringify(this.callHistory));
  //   const paginatedData = callHistory.splice(this.first, this.first + this.rows);
  //   if (paginatedData.length > 0) {
  //     paginatedData.forEach(item => {
  //       item.custTtype = item.NumberCalled ? 'Call' : 'No Interaction';
  //     });
  //     this.paginatedData = paginatedData;
  //   }
  //   console.log(event, this.paginatedData);
  // }

  
  getAudioFile(item) {
    this.managerService.getRecordingFiles(item.Recording).subscribe(data => {
    //  console.log('getAudioFile', data);
      const binaryData = 'data:' + data.MimeType + ';base64,' + data.result;
      const binary = Utils.convertDataURIToBinary(binaryData);
      const blob = new Blob([binary], { type: data.MimeType });
      const blobUrl = URL.createObjectURL(blob);

      //this.audio.src = blobUrl;
      //this.audio.load();
      //this.audio.play();

      let EL_audio: any = document.querySelector('#myAudio_' + item.ID + '_' + item.CaseID);
      EL_audio.src = blobUrl;
      EL_audio.load();
      EL_audio.play();
      EL_audio.style.display = 'block';

      //this.audio.addEventListener('loadstart', () => {
      //    console.log('loadstart');
      //    item[0].playAudioBtnText = 'Loading';
      //});
      //this.audio.addEventListener('loadeddata', () => {
      //    item[0].playAudioBtnText = '';
      //    console.log('loadeddata');
      //});
      //this.audio.addEventListener('playing', () => {
      //    item[0].playAudioBtnText = 'Playing';
      //});
      //this.audio.addEventListener('ended', () => {
      //    item[0].playAudioBtnText = '';
      //});
    });
  }

  playAudio(item) {
    this.getAudioFile(item);
  }

  pauseAudio(item) {
    this.audio.pause();
    item[0].playAudioBtnText = 'Preview';
  }
  getCaseDetailsConfig(activityId: any, userID: any, caseID: any, queueID: any): any {
    this.loaderService.setOnDemandLoading(true);
    this.managerService.getCaseDetailsConfig(activityId, userID, caseID, queueID).subscribe({
      next: (res) => {
    //  console.log('getCaseDetailsConfig', res);
      this.caseDetailsConf = res;
      this.menuList = [];
      this.loaderService.setOnDemandLoading(true);

      const dispostiontab = this.caseDetailsConf.Tabs.findIndex(tab => tab.TabName == 'Disposition');
      const communicationHistory = this.caseDetailsConf.Tabs.findIndex(tab => tab.TabName == 'Communication History');

      if (dispostiontab !== -1 && communicationHistory !== -1) {
        this.caseDetailsConf.Tabs[communicationHistory].TabName = 'Fax';
        [this.caseDetailsConf.Tabs[dispostiontab], this.caseDetailsConf.Tabs[communicationHistory]] = [
          this.caseDetailsConf.Tabs[communicationHistory],
          this.caseDetailsConf.Tabs[dispostiontab],
        ];
      }

      this.caseDetailsConf.Tabs.forEach((cdObj: any, index) => {
        cdObj.TabValue = Utils.toCamelCase(cdObj.TabName);
        if (cdObj.Groups && !this.isSubMenuItem(cdObj.TabValue)) {
          this.menuList.push({ id: index, label: cdObj.TabName, value: cdObj.TabValue });
        }

        // For setting view only flag initially to User Information tab
        if (cdObj.TabValue == 'userInformation' && cdObj.Groups) {
          cdObj.Groups.forEach((group: any) => {
            group.viewMode = true;
            group.Fields.forEach((field: Field) => {
              field.viewMode = true;
            });
          });
        }

     

          // For setting view only flag initially to User Information tab
          if (cdObj.TabValue == 'userInformation' && cdObj.Groups) {
            cdObj.Groups.forEach((group: any) => {
if(group?.GroupName == 'PhoneNumbers'){
  group.Fields.forEach((field: Field) => {
    field.isFromAPI = true;
  });
}else{
  group.Fields.forEach((field: Field) => {
    field.isFromAPI = false;
  });
}

            
            });
          }
      });

      

     // console.log('MenuList:', this.menuList);

      if (this.mainMenuListAdd && this.mainMenuListAdd.length > 0) {
        this.mainMenuListAdd.forEach(menu => {
          let tempLst = [];
          tempLst = this.menuList.filter(tempmenu => tempmenu.value == menu.name);
          if (tempLst.length <= 0) {
            this.menuList.push({ id: this.menuList.length, label: menu.label, value: menu.name });
          }
        });
      }
      this.menuList.sort(this.compare);
     // console.log('this.menuList:', this.menuList);
      this.menuList[0].isSelected = true;

     // console.log('menulist', this.menuList);
      this.selectedTab = this.menuList[0].value;
      this.loaderService.setOnDemandLoading(false);
    },
      error: (err) => {
        this.loaderService.setOnDemandLoading(false);
        console.error('getCaseDetailsConfig failed', err);
      }
    });
  }
  compare(a, b) {
    // Use toUpperCase() to ignore character casing
    const A = a.id;
    const B = b.id;

    let comparison = 0;
    if (A > B) {
      comparison = 1;
    } else if (A < B) {
      comparison = -1;
    }
    return comparison;
  }
  getConfByTabName(tabValue: string) {
    let conf: any;
    //console.log(tabValue, this.caseDetailsConf.Tabs)
    this.caseDetailsConf.Tabs.forEach((cdObj: any) => {
      if (cdObj.TabValue === tabValue) {
        conf = cdObj;
      }
    });
    //console.log(conf, 'conf');
    return conf;
  }

  //setUserStatus(statusId, queueId) {
  //  this.tmQueueService.setUserStatus(statusId, queueId).subscribe(data => {
  //    //console.log("setUserStatus response", data);
  //  });
  //}

  handleFormValueChange(formData: any) {
    console.log('updated data', formData);
  }

  goBack() {
    this.queueService.SetUnsubmittedCaseForReadonly(false);
    let isFromSearchQueue = this.queueService.getFromSearchQueue();
   // console.log(isFromSearchQueue, 'search');
    if (isFromSearchQueue && this.queueService.getisEscalatedCases()) {
      this.goToQueue();
    } else {
     // console.log(this.queueService.getselectedQueueId() + 'insidequeueoptiongoback');
      this.appService.setUserStatus(6, this.queueService.getselectedQueueId());
      this.queueService.setisEscalatedCases(false);
      this.queueService.SetDisableHeader(false);
      this.mainController.stopVideoRecording();
      this.mainController.setisCaseDetail(false);
      //this.location.back();
      this.mainController.setUnmappedCaseID('');
      this.clearDestroy();
      this.mainController.setUnmappedUserID('');
      this.mainController.setIsCaseUserUnmapped(null);
      this.mainController.setIsUnknownContact(false);
      this.queueService.SetVoicemailDetailsReply(false);
      this.mainController.setshowSearchDialog(false);
      this.queueService.notifyOtherFromTaskMenu({
        refresh: true,
        menuName: this.queueType,
      });
      // this.queueService.SetTaskSelectedQueue({
      //   refresh: true,
      //   menuName: selectedQueue,
      // });
      this.queueService.setTaskMenuQueueSelected({
        pageRefresh: true,
        isPageInitCompleted: false,
        queueType: this.queueType,
      });

      this.router.navigate([Utils.fetch('clientAbbreviation') + '/Queue/' + this.queueType], {
        queryParams: { qid: this.queueService.getselectedQueueId() },
      });
    }
    this.flexStore.remove('CaseCreatedForDifferentUser');
    this.flexStore.remove('DifferentUserCasesForTransfers');
    this.flexStore.remove('NewUserCases');
    this.queueService.setValueParentChk(true);
    this.queueService.setValueChildChk(false);
    this.appService.caseDirtyStateCache.clear();
  }
  goToQueue() {
    this.appService.caseDirtyStateCache.clear();
    this.bsModalRef.hide();
    this.queueService.notifyOtherFromTaskMenu({
      refresh: true,
      menuName: '',
    });

    // this.dialerService.setIsAgentStatusChangeRequired(false);
    // this.dialerService.setDialerCancelledStatus(false);
    this.tmQueueService.setisTopMenuQueueSelected(true);
    this.tmQueueService.setisQueueTaskMenuLoaded(true);

    // this.queueService.setTaskMenuQueueSelected({
    //   pageRefresh: false,
    //   isPageInitCompleted: true,
    //   queueType: 'Inbound'
    // }
    // );
    this.router.navigate([Utils.fetch('clientAbbreviation') + '/Queue']);
  }
  getAllDynamicFormData() {
    // if (this.children && this.children.length > 0) {
    this.children?.forEach((child, index) => {
      child.emitFormData();
    });
    let formData: any = this.formDataService.getFormData();
    let disposition = this.appService.getDispositionPayload();
    formData.disposition = disposition;
    console.log('All Tabs Data:', formData);
    this.allDynamicTabsData = formData;
    // }
  }

  onChildFormData(childData: any, selectedTab: string) {
    //console.log('onChildFormData:', selectedTab, childData);
  }

  handleFormDataHasError(hasError, selectedTab) {
    // Disable submit button if hasError
    /*
        if (hasError) {
          this.formDataValid = false;
        } else {
          this.formDataValid = true;
        }
        */

    if (!this.appService.getDispositionPayload()?.DispositionType) {
      this.formDataValid = false;
    } else {
      this.formDataValid = true;
    }

    //console.log(selectedTab + ' form has error', hasError);
  }

  ngOnDestroy() {
    // Clean up countdown timer
    if(!this.queueService.getIsUserChange()){
      this.dialerService.setStopHoldTimer(true);
      this.dialerService.setaccumulatedHoldSeconds(0);
      this.dialerService.setHoldCallDuration("0:00");
    }
   
    if (this.dispositionTimerInterval) {
      clearInterval(this.dispositionTimerInterval);
    }
    
    this.appService.setIsAddNewUser(false);
      this.appService.setConfirmationStatus(false);
      this.mainController.setcurrentRecordUserID(null);
      this.appService.setCaseUserDetail(null);
      this.mainController.setshowSearchDialog(false);
      this.mainController.resetPostCallTimeout();
    //this.queueService.SetVoicemailDetailsReply(false);
    this.releaseLocks();
    this.additionalinfoService.clearAdditionalInfo();
    this.subs.forEach(sub => sub.unsubscribe());
    let type = this.queueType;
    if (type == 'Outbound' || type == 'Inbound' || type == 'Search') {
      //this.appService.setUserStatus(6, this.queueService.getselectedQueueId());
      this.dialerService.setResetCallSummary(true);
    }
    if (this.getAgentStatus() != 5 && !this.ConfirmUserNav) {
      //5->oncall
      this.queueService.setCallID('');
    }
    if (this.getAgentStatus() != 5) {
          this.queueService.setCaseDetails_ENABLECONTROLS(false);
    }
    //this.queueService.setCaseDetails_ENABLECONTROLS(false);
    this.appService.setDispositionPayload(null);
    this.appService.setEditedCases([]);
    this.flexStore.remove('userInformation_conf');
    this.flexStore.remove('cases_conf');
    this.formDataService.clearFormData();
    this.appService.setNotesData(null);
    this.appService.setDocumentData(null);
    this.appService.setDateTimePickerData(null);
    this.mainController.setisCaseDetail(false);
    this.mainController.resetValidationModal();
  }

  @HostListener('document:click', ['$event'])
  OnClickOutside(event: MouseEvent): void {
    const dropdown = document.querySelector('.dropdown-div');
    if (dropdown && !dropdown.contains(event.target as Node) && this.showDropDown) {
      //console.log('dropdown listner');
      this.showDropDown = !this.showDropDown;
      $('.dropdown-menu').attr('style', 'display: none');
    }
  }

  toggleSubmitDropdown(event: MouseEvent) {
   // console.log('showDp', this.showDropDown);
    this.showDropDown = !this.showDropDown;
    if (this.showDropDown) {
      $('.dropdown-menu').attr('style', 'display: block');
      if (event) {
        event.stopPropagation();
      }
    } else {
      $('.dropdown-menu').attr('style', 'display: none');
    }
  }

  isSubMenuItem(tabName: string): boolean {
    let isSubmenu: boolean = false;
    this.subMenuList.forEach(menu => {
      const templst = menu['SubMenu'].filter(subMenus => subMenus['Name'] == tabName);
      if (templst && templst.length > 0) {
       // console.log('true:', templst);
        isSubmenu = true;
        if (!this.mainMenuListAdd.includes(menu['MenuName'])) {
          this.mainMenuListAdd.push({ name: menu['MenuName'], label: menu['MenuLabel'] });
        }
      }
    });
    return isSubmenu;
  }
  hasSubMenu(): boolean {
    const tempLst = this.subMenuList.filter(menu => {
      menu.MenuName == this.selectedTab;
    });
    if (tempLst && tempLst.length > 0 && tempLst[0]['SubMenu'].length > 0) {
      return true;
    }
    return false;
  }
  SubMenuSelected(selectedIndex: number) {
    const tempLst = this.subMenuList.filter(menu => menu.MenuName == this.selectedTab);
    if (tempLst && tempLst.length > 0) {
      this.selectedSubmenu = tempLst[0]['SubMenu'][selectedIndex]['Name'];
      this.subMenulstSelected.forEach((ele, i) => {
        if (ele.Name === this.selectedSubmenu) ele.IsSelected = true;
        else ele.IsSelected = false;
      });
    } else {
      this.selectedSubmenu = '';
    }
   // console.log('selectedSubMenu', this.subMenulstSelected);
  }
  hasPredefinedTemplate(tabValue: string) {
    const pdTemplates = ['userInformation', 'cases', 'disposition', 'fax', 'additionalInformation'];
    if (pdTemplates.includes(tabValue)) {
      return true;
    }
    return false;
  }
  isReadOnlyCase(){
    return this.queueService.getReadOnlyCase();
  }
  getAvatarByID(userID: any) {
    this.userService.getAvatarByUserID(userID).subscribe(async response => {
      console.log('user Avatar', response.Response.Data);
      const txtURL = response.Response.Data;
      if (txtURL !== null && txtURL !== undefined) {
        this.getImage(response.Response.Data);
      } else {
        this.URL = this.baseHref + '/assets/images/icon-user-pic.png';
      }
    });
  }
  getImage(file: any) {
    this.managerService.getRecordingFiles(file).subscribe(data => {
      console.log('getImageAvatar', data);
      this.URL = 'data:' + data.MimeType + ';base64,' + data.result;
    });
  }
  releaseLocks() {
    if (!this.isReadOnlyCase()) this.tmQueueService.releaseLocks().subscribe();
  }
  IsCallAllowed() {
    return this.IsEnableCall && !this.isReadOnlyCase() ? true : false;
  }
  saveChanges() {
    this.getAllDynamicFormData();
    const pl = {
        calleeUserId: this.appService.getIsAddNewUser() ? "-1" : (this.queueService.getselectedUserID() != 'null' ? this.queueService.getselectedUserID() : null),
      activityId: this.activityId,
      queueId: this.queueService.getselectedQueueId(),
      notes: '',
      scheduledInteractionID: null,
      callID: this.queueService.getCallID(),
      transferCaseID: this.transferCaseID != 'null' ? this.transferCaseID : null,
      isExternalTransfer: this.isExternalTransfer,
      isFreeDialer: this.isFreeDialer,
    };
    if (
      this.dialerService.getIsEnableAddNewNumber() &&
      this.dialerService.getIsSaveUserRecord() &&
      (this.dialerService.getCallDisconnected() || this.dialerService.getCallStatus() == 'Ringing')
    ) {
      if (
        this.allDynamicTabsData.userInformation != null &&
        this.allDynamicTabsData.userInformation.PhoneNumbers != null
      ) {
        this.addDialedNumber();
      }
    }
    const payload = { ...pl, ...this.allDynamicTabsData };
    payload.cases = this.appService.getEditedCases();

    // Only include cases that were actually modified or newly created —
    // same filter as onSubmit() to prevent navigated-but-unedited cases
    // from being sent on transfer.
    const dirtyCache = this.appService.caseDirtyStateCache;
    const dirtyCaseIdStrings = new Set<string>();
    dirtyCache.forEach((_, k) => dirtyCaseIdStrings.add(String(k)));
    const newCaseIdStrings = new Set<string>([
      ...(this.newUserCases ?? []).map((c: any) => String(c.CaseID)),
      ...(JSON.parse(this.flexStore.get('NewUserCases')) ?? []).map(String),
    ]);
    if (dirtyCaseIdStrings.size > 0 || newCaseIdStrings.size > 0) {
      payload.cases = (payload.cases ?? []).filter((c: any) => {
        const id = String(c.CaseID);
        return dirtyCaseIdStrings.has(id) || newCaseIdStrings.has(id);
      });
    } else {
      payload.cases = [];
    }

    let findMemberId = this.appService.getLookUpMemberId();
    if (findMemberId?.length > 0) {
      payload.cases?.forEach(item => {
        const fieldAttr = Object.keys(item);
        fieldAttr?.forEach(field => {
          let index = findMemberId.findIndex(fmItem => fmItem.caseId == item.CaseID && fmItem.fieldName == field);
          if (index !== -1) {
            item[field] = findMemberId[index].findMemberId;
          }
        });
      });
    }

    //Different user created case, assigning UserId
    const loginParams = this.webStorageService.getItemFromSessionStorage('loginParams');
    if(loginParams){
      let allowDifferentUserCase = (loginParams?.AllowDifferentUserCase?.toLowerCase() === 'true'); 
      let otherUserCases = JSON.parse(this.flexStore.get('CaseCreatedForDifferentUser'));
      let otherUserCasesForTransfers = JSON.parse(this.flexStore.get('DifferentUserCasesForTransfers'));
      if(allowDifferentUserCase){
        if(otherUserCases){
          otherUserCases?.forEach(u => {
            payload?.cases?.forEach(c => {
              if(u && u.CaseID && u.CaseID.map(String).includes(c.CaseID)){  
                c.OtherUserID = u.UserID;
              }
            });
          });
        }

        if(otherUserCasesForTransfers){
          otherUserCasesForTransfers?.forEach(u => {
            payload?.cases?.forEach(c => {
              if(u && u.CaseID && u.CaseID.map(String).includes(c.CaseID)){  
                c.OtherUserID = u.UserID;
              }
            });
          });
        }
      }
    }

    //Date Time Picker Data
    let dateTimePickerData = this.appService.getDateTimePickerData();
    dateTimePickerData?.forEach(item => {
      switch (item.tabName) {
        case 'cases':
          payload.cases.forEach((caseItem, index) => {
            if (caseItem.CaseID == item.caseId) {
              payload.cases[index][item.fieldName] = item.convertedDateValue;
            }
          });
          break;
        case 'userInformation':
          payload.userInformation[item.fieldName] = item.convertedDateValue;
          break;
        case 'disposition':
          switch (item.fieldName) {
            case 'UserFollowupDateTime':
              payload.disposition['FollowUpDateTime'] = item.convertedDateValue;
              break;
            case 'CallerFollowupDateTime':
              payload.disposition['FollowUpDateTime'] = item.convertedDateValue;
              break;
          }
          break;
      }
    });
    //Document Data
    let documentData = this.appService.getDocumentData();
    payload.cases.forEach(item => {
      let documentIndex = documentData.findIndex(ndItem => ndItem.caseId == item.CaseID);
      if (documentIndex !== -1) {
        let oldDocJSONStr = documentData[documentIndex].oldValue;
        let newDocJSONStr = JSON.stringify(item.Documents);
        if (oldDocJSONStr === newDocJSONStr) delete item.Documents;
      }
    });
    // Notes Data
    this.getCaseNotes(payload);
    payload.notes = this.appService.getDispositionNotes(); 
    this.managerService.saveChanges(this.filterPayload(payload)).subscribe((res: any) => {

        let isAddNewUser = this.appService.getIsAddNewUser();
        if ((this.newUser == 'New User' || this.newUser == 'Change User') && isAddNewUser) {

            if (res.Response?.Data?.UserID) {
                this.queueService.setSelectedNewUserId(res.Response?.Data?.UserID);
                this.selectedUserID = res.Response?.Data?.UserID;
                this.queueService.setselectedUserID(this.selectedUserID);
                this.appService.setIsAddNewUser(false);
                this.mainController.setUnmappedUserID(this.selectedUserID);
                this.mainController.setcurrentRecordUserID(this.selectedUserID);
            }
        }
      // failure
      if (res.Response.Status != 1) {
        this.resetNotesValue(payload,false);
        this.errorMessage = res.Response.Message;
        console.log('Error:', res.Response.Message);
      }else{
        this.resetNotesValue(payload,true);
        let tempCases = JSON.parse(this.flexStore.get('CaseCreatedForDifferentUser'));
        this.queueService.setOtherUserCasesForCancelTransfer(tempCases);
        this.flexStore.remove('CaseCreatedForDifferentUser');
        this.flexStore.remove('DifferentUserCasesForTransfers');
        this.flexStore.remove('NewUserCases');
        this.queueService.setValueParentChk(true);
        this.queueService.setValueChildChk(false);
        this.queueService.setTransferInteractionID(res.Response?.Data?.InteractionID);
      }
    });
  }
    saveFreeDialerChanges() {
        
        const pl = {
            activityId: this.activityId,
            queueId: this.queueService.getselectedQueueId(),
            notes: '',
            callID: this.queueService.getChildCallID(),
            isExternalTransfer: this.isExternalTransfer,
            isFreeDialer: this.isFreeDialer,
        };
        
        this.managerService.saveChanges(pl).subscribe((res: any) => {

            
        });
    }

  private getCaseNotes(payload: any) { 
    payload.cases.forEach(item => { 
      if (!this.notesHelper.isEmptyOrWhitespace(item.Notes)) {
        item.Notes = this.generateNotesContent(item.Notes,'','');
       }
       else {
        delete item.Notes;
       }
    });
  }

    resetNotesValue(payload: any,isSuccessEmptyNotes : boolean){
      let isChanged = false;
      payload.cases?.forEach(element => {
          if(isSuccessEmptyNotes){
            element.Notes = '';
            isChanged = true;
            this.appService.setEditedCases([]);
          }
          else{
            if(!this.notesHelper.isEmptyOrWhitespace(element.Notes))
            {
              isChanged = true;
              element.Notes=this.notesHelper.decodeUnicode(element.Notes);  
            }       
          } 
        });
        if(isChanged){
          this.filterPayload(payload);
        }
    }
    getLastValueFromNoteHistory(htmlString: string) {
          if (!htmlString) return '';
          const parser = new DOMParser();
          const doc = parser.parseFromString(htmlString, 'text/html');
          const noteSpans = doc.querySelectorAll('.NotesPre');
          if (noteSpans.length > 0) {
            let isLastNoteNull = noteSpans[noteSpans.length - 1].textContent || '';
            return this.notesHelper.isEmptyOrWhitespace(isLastNoteNull) ? '' : isLastNoteNull;
          }
          return '';
  }; 
  openModal() {
    this.display = 'block';
  }

  onCloseHandled() {
    this.display = 'none';
  }

  loadVoicemailAudio(file: any) {
    this.managerService.getRecordingFiles(file).subscribe(data => {
      console.log('loadVoicemailAudio', data);
      const binaryData = 'data:' + data.MimeType + ';base64,' + data.result;
      const binary = Utils.convertDataURIToBinary(binaryData);
      const blob = new Blob([binary], { type: data.MimeType });
      const blobUrl = URL.createObjectURL(blob);
      let audioSource: any = blobUrl;
      this.recordingDetails = audioSource;
      this.isRecordLoaded = true;
     // console.log(blobUrl, this.recordingDetails);
      this.cdr.detectChanges();
    });
  }
  UpdateNewCases(event) {
    this.newUserCases = event;
  }
  UpdateSelectedCaseID(caseID) {
    this.selectedCaseId = caseID;
  }
  IsUserLevelLocked(isLock) {
    this.isUserLevelLocked = isLock;
  }
  updateUserData(userData) {
    let actionItemID = this.activityId + '-' + userData.UserID + '-' + userData.CaseID;
    this.setCurrentCallee(userData.UserID);
    this.appService.setActionItemId(actionItemID);
    this.setUserDetails(actionItemID);
    this.loadConfiguration();
  }
  loadConfiguration() {
    this.getCaseDetailsConfig(
      this.activityId,
      this.selectedUserID,
      this.selectedCaseId,
      this.queueService.getselectedQueueId()
    );
    this.appService.setTransferCaseID(this.selectedCaseId);
    //this.CheckAndSetCaseLock(this.selectedCaseId, this.queueService.getselectedQueueId());
  }
  //This is required for cases only
  CheckAndSetCaseLock(caseId, QueueId) {
      if (caseId && caseId != 'undefined' &&  caseId != 'new_' && QueueId) {
      this.queueService.GetCaseLocks(caseId).subscribe(data => {
        if (data) {
          if (!data.Response?.Data?.Locked) {
            this.queueService.SetCaseLock(caseId, QueueId).subscribe(res => {
             // console.log(res);
            });
          }
        }
      });
    }
  }
  setUserDetails(value) {
    // A new action item means a new call/user context — clear stale dirty-case
    // flags so unedited cases from a previous interaction are not included in
    // this call's submit payload (critical for inbound transfer / component reuse).
    this.appService.caseDirtyStateCache.clear();
    this.appService.setEditedCases([]);
    this.newUserCases = [];
    //--------------

    const paramArr = value?.split('-');
    let caseId = value.includes('R') ? paramArr[paramArr.length - 2] : paramArr[paramArr.length - 1];
    let userID = value.includes('R') ? paramArr[paramArr.length - 3] : paramArr[paramArr.length - 2];
    // For queues where activityId is not set at queue-selection time (e.g. Email),
    // derive it from the first segment of the action item ID.
    if (!this.activityId && paramArr[0] && paramArr[0] !== 'null') {
      this.activityId = paramArr[0];
    }
    this.selectedCaseId = caseId != 'null' && caseId != 0 && caseId != 'new_' ? caseId : null;
    this.queueService.setDefaultCaseID(this.selectedCaseId);
    this.selectedUserID = userID != 'null' && caseId != 'new_' ? userID : null; //&& caseId != 'new_' if new_ value passing then considering its new user.
    //if (!value.includes('R')) this.SetCurrentActionItem(value);
      this.queueService.setselectedUserID(this.selectedUserID);
    console.log('Selected Userid', this.selectedUserID);
      if ((this.selectedUserID == 0 || this.selectedUserID == '0')) {
          this.mainController.setshowSearchDialog(true);
          this.mainController.setIsCaseUserUnmapped(true);
          this.mainController.setUnmappedCaseID(this.selectedCaseId);
          this.mainController.setUnmappedUserID(this.selectedUserID);
      } else if ((this.mainController.getIsCaseUserUnmapped() && this.selectedUserID != 0)) {
          this.showchangeusr();
          this.mainController.setUnmappedUserID(this.selectedUserID);
      }

      this.queueService.setReadOnlyCase(value.includes('R') ? true : false);
      this.mainController.setIsReadOnlyCase(this.queueService.getReadOnlyCase());
      this.dialerService.setCaseLock(this.queueService.getReadOnlyCase());

      if (this.selectedUserID != null) {
          this.mainController.setcurrentRecordUserID(this.selectedUserID);
          this.queueService.getUserDetails(this.selectedCaseId, this.selectedUserID).subscribe(res => {
          this.searchedUserData = res.Response.Data;
          this.appService.setCaseUserDetail(res.Response.Data);
          this.setUserInfo();
          this.crmUserID = res.Response.Data.CrmUserID;
          const clientAbbreviation = Utils.fetch('clientAbbreviation');
          if (clientAbbreviation === 'S2U')
          {
              this.mainController.setItemsforSalesforce(res, this.queueType);
          }
      });
          
      //this.getAvatarByID(this.selectedUserID);
          if (this.selectedUserID && this.selectedUserID >0) {
              this.getCallHistoryDetails();
          }
    }
      //only for new user(unknown contact)
      if (this.selectedUserID == null && this.mainController.getIsUnknownContact()) {
          let Data: any = {};
          Data.PhoneNumbers = null;
          this.appService.setCaseUserDetail(Data);
      }
  }
  
  setCallHistoryData(callHistory) {
    let callHistoryDetails = [];
    if (callHistory?.length > 0) {
      for (let i = 0; i < callHistory.length; i++) {
        for (let j = 0; j < callHistory[i].length; j++) {
          callHistoryDetails.push(callHistory[i][j]);
        }
      }
    }
    return callHistoryDetails;
  }
  getCallHistoryDetails(page: number = 1) {  
    this.queueService
      .getCallHistory(this.selectedUserID, page, this.queueService.getCallID())
      .subscribe({
        next: (res) => {
          const data = res?.Response?.Data ?? {};
          const itemsList = Array.isArray(data.ItemsList) ? data.ItemsList : [];

          const flattened: any[] = itemsList.flat
            ? itemsList.flat()
            : ([] as any[]).concat(...itemsList);
  
          flattened.sort(
            (a, b) => new Date(b.Date).getTime() - new Date(a.Date).getTime()
          );
  
  
          flattened.forEach((item) => {
            //item.custTtype = item.NumberCalled ? 'Call' : 'No Interaction';
            item.custTtype = item.NumberCalled && item.Type.toLowerCase() !='nointeraction' ? 'Call' : 'No Interaction';
          });
  
          // Bind only current page
          this.paginatedData = flattened;
          this.TotalItemCount = res?.Response?.Data?.TotalItemCount;
          this.loadedItemCount += flattened.length;
          // Update totals
          this.rows = data.ItemsPerPage ?? this.rows;
          this.totalRecords = data.TotalItemCount ?? (data.Pages ?? 0) * this.rows;
          this.currentPage = data.Page ?? page;
        },
        error: (err) => {
          console.error('Failed to load call history page', err);
          this.paginatedData = [];
        },
        
      });
  }
  // getCallHistoryDetails() {
  //   this.queueService.getCallHistory(this.selectedUserID, 1, this.queueService.getCallID()).subscribe(response => {
  //     console.log('getCallHistory', response.Response.Data.ItemsList[0]);
  //     this.callHistory = this.setCallHistoryData(response.Response.Data.ItemsList);
  //     this.callFollowUpData();
  //     if (this.rows < this.defaultCount) {
  //       this.rows = this.callHistory.length;
  //     }
  //     this.onPageChange({ first: this.first, rows: this.rows });
  //   });
  // }

  callFollowUpData() {
    if (this.callHistory && this.callHistory.length > 0) {
      const date = new Date();
      let filteredItems = this.callHistory.filter(item => {
        let localDateFormat = this.utils.GetESTtoLocalTimeZone(item.FollowUpDate);
        const itemDate = new Date(localDateFormat);
        return itemDate >= date;
      });
      if (filteredItems && filteredItems.length > 0) {
        this.followUpItem = filteredItems.reduce((prev, curr) => {
         // console.log(prev, curr);
          let date1 = new Date(prev.FollowUpDate);
          let date2 = new Date(curr.FollowUpDate);
          return date1 < date2 ? prev : curr;
        });
       // console.log(this.followUpItem);
      }
    }
  }
  checkCurrentDay(date) {
    return new Date(date).setHours(0, 0, 0, 0) === new Date().setHours(0, 0, 0, 0);
  }
  setCurrentCallee(userID) {
    this.tmQueueService.setCurrentCallee(this.queueService.getCallID(), userID).subscribe(data => {
     // console.log('setCurrentCallee response', data);
    });
  }
  TranscriptTabEnabled(isShow) {
    let item = this.rightPanelTabs
      .filter(tab => tab.label == 'Transcript')
      .map(trans => {
        trans.isDisabled = isShow;
        trans.isSelected = !isShow;
        return trans;
      });

    this.rightPanelTabs.forEach(element => {
      element.isSelected = false;
    });
    this.rightPanelTabClick(item[0]);
    //this.cdr.detectChanges();
  }
  viewTranscript(item) {
    let RecordingId = null;
    let callId = null;
    if (item.Recording != null && item.Recording != '') {
      var allRecording = item.Recording.split('_');
      RecordingId = allRecording[2];
      RecordingId = RecordingId.split('.')[0];
      callId = allRecording[1];
     // console.log(RecordingId, callId);
    }

    const initialState = {
      Heading: 'Transcript',
      showHeading: 'true',
      InteractionId: item.ID,
      CallID: callId,
      RecordingID: RecordingId,
    };
    const config: ModalOptions = { backdrop: 'static', class: 'call-transcript', initialState };
    this.modalRef = this.modalService.show(CallTranscriptComponent, config);
  }

  // isInternalTransferCall() {
  //   return this.mainController.isInternalTransferCall();
  // }

  getAgentStatus() {
    let status = this.mainController.getAgentStatus();
    return status;
  }
  setQueueInfoforSoftphoneinitialization(queueId: any) {
    // // this.loaderService.display(true);
       // this.mainController.initializeSoftPhone();
        if (this.queueType === 'Inbound') {
          this.automatedQueue = true;
        }
        this.callMaincontrollerQueueDetails(queueId);
    }
    callMaincontrollerQueueDetails(queueId) {
        this.mainController.GetqueueDetails(queueId, this.automatedQueue).then(res => {
            let det: any;
            det = res;
            queueDialerType = det.dialerType;
            QueueInteractionType = det.interactionType;
            //this.dialerService.setDeviceReady(true);
            //this.appService.setUserStatus(6, this.selectedQueueId);
        });
    }
  answerInboundNextCall() {
    if (this.callAlertInterval) clearInterval(this.callAlertInterval);
    if (this.ActionItemID === '') {
      this.selectedQueueId = this.selectedQueueId ?? localStorage.getItem('qid');
      this.getNextCallDetails(this.selectedQueueId);
    }
    //this.setCurrentActionItem(this.selectedQueueId, this.ActionItemID);
    const data: any = {};
    data.dialerType = queueDialerType;
    data.navigateURL = this.ActionItemID;
    data.interactionType = QueueInteractionType;
    this.ShowManualInboundcallAlert = false;
    //this.headerService.setManualInboundCallAlert({
    //  show: false,
    //  incomingCallAlertText: '',
    //});
    this.mainController.CallCurrentActionItems(this.queueService.getselectedQueueId(), data);
  }
  getNextCallDetails(queueID) {
    this.ActionItemID = queueID + (this.conference ? '-conference_' : '-inbound_') + this.queueService.getCallID();
  }
  rejectCall() {
    this.rejectInboundCall(this.queueService.getCallID());
    this.dialerService.setcallEnded(true);
    this.ShowManualInboundcallAlert = false;
    this.headerService.setManualInboundCallAlert({
      show: false,
      incomingCallAlertText: '',
    });
    if (this.callAlertInterval) clearInterval(this.callAlertInterval);
  }

  rejectInboundCall(_callId) {
    this.tmQueueService.rejectCall(_callId).subscribe(data => {
      //console.log("isInboundCallConnected response", data);
    });
    this.dialerService.setIsTransferCallRejected(true);
  }

  eInboundCallHandler = function (callDetails) {
    this.inboundCallAlert(callDetails);
  };

  inboundCallAlert = function (callDetails) {
    if (this.mainController.getAgentStatus() != 8) {
      //8->post call
      this.mainController.callEnded_phnctrl();
    }
    this.ShowManualInboundcallAlert = true;
    let Number = callDetails.find(i => i.key === 'number').value,
      name = Utils.cleanString(callDetails.find(i => i.key === 'name').value),
      queue = Utils.cleanString(callDetails.find(i => i.key === 'queue').value),
      _callId = callDetails.find(i => i.key === 'callID').value,
      queuedTime = this.convertServerDate(callDetails.find(i => i.key === 'queuedTime').value),
      //now = this.convertServerDate(callDetails.find(i => i.key === 'CurrentTime').value),
      now = 0,
      secondsRemaining = Math.floor(Math.min(60, 90 - (now - queuedTime) / 1000)),
      conference = callDetails.find(i => i.key === 'conference').value;

    this.callId = _callId;
    this.queueService.setCallID(_callId);
    console.log('Outbound inboundCallAlert CALLID:' + this.queueService.getCallID());
    this.newCallSnd.play();
    if (!conference) {
      this.countdownField = '00:' + (secondsRemaining < 10 ? '0' : '') + secondsRemaining;
      // btnView.addSubView(countdownField);
    }

    this.IncomingCallAlerttext =
      'Incoming ' +
      (conference ? 'conference with ' : 'call from ') +
      (Number == null ? '' : Number) +
      (name && name != '' ? ' - ' + name : '') +
      (queue && queue != '' ? ' (' + queue + ')' : '') +
      (this.postCall ? ' - Finish the current call to answer.' : '');

    if (this.callAlertInterval) clearInterval(this.callAlertInterval);
    this.callAlertInterval = setInterval(() => {
      secondsRemaining--;
      this.countdownField = '00:' + (secondsRemaining < 10 ? '0' : '') + secondsRemaining;
       this.headerService.setCountdownField(this.countdownField);
      this.headerService.setManualInboundCallAlert({
      show: true,
      incomingCallAlertText: this.IncomingCallAlerttext,
    });
      if (secondsRemaining <= 0) {
        // notification.close();
        clearInterval(this.callAlertInterval);
        this.ShowManualInboundcallAlert = false;
        this.headerService.setManualInboundCallAlert({
          show: false,
          incomingCallAlertText: this.IncomingCallAlerttext,
        });
        this.rejectInboundCall(this.queueServices.getCallID());
        // im.InteractionService.instance().RejectCall({ callID: call.CallID };
      }
    }, 1000);
  };

  // disposition countdown timer method
  startDispositionCountdownTimer(): void {
    // Clear existing timer if any
    if (this.dispositionTimerInterval) {
      clearInterval(this.dispositionTimerInterval);
    }
    
    // Reset timer
    this.dispositionTimerSeconds = Math.floor(this.dispositionTimerDuration); // Ensure integer
    this.showAddMoreTime = false; // Reset the add more time flag
    console.log('Timer initialized with:', this.dispositionTimerSeconds, 'seconds');
    
    // Start the countdown
    this.dispositionTimerInterval = setInterval(() => {
      this.dispositionTimerSeconds--;
      
      // Show "Add More Time" when timer reaches 50% of original duration
      const halfDuration = Math.floor(this.dispositionTimerDuration / 2);
      if (this.dispositionTimerSeconds <= halfDuration && !this.showAddMoreTime) {
        this.showAddMoreTime = true;
        console.log(`Timer reached 50% (${halfDuration}s remaining), showing Add More Time option`);
      }
      
      if (this.dispositionTimerSeconds <= 0) {
        clearInterval(this.dispositionTimerInterval);
        // Timer finished - show the timeout modal
        this.showDispositionTimeoutModal = true;
        this.cdr.detectChanges();
      }
    }, 1000);
  }

  // Configure the timer duration
  setDispositionTimerDuration(durationInSeconds: number): void {
    this.dispositionTimerDuration = Math.floor(durationInSeconds); // Ensure integer
    this.dispositionTimerSeconds = this.dispositionTimerDuration; // Initialize current timer
    console.log('Timer duration configured to:', this.dispositionTimerDuration, 'seconds');    
  }

  // Close disposition timeout modal
  closeDispositionTimeoutModal(): void {
    this.showDispositionTimeoutModal = false;
    // Restart timer
    //this.dispositionTimerSeconds = 40;
    this.startDispositionCountdownTimer();
  }

  convertServerDate = function (date) {
    if (!date) return null;
    const dateFormat = /\/Date\(.*\)\//gi;
    if (dateFormat.test(date)) return new Date(parseInt(date.replace('/Date(', '').replace(')/', '')));
    else return new Date(date);
  };
  disableSubmitPauseButton(data) {
    this.IsDisableSubmitPauseButton = data;
  }

  getRequestType() {
    return this.mainController.getRequestType();
  }

  getDialerType() {
    return this.mainController.getDialerType();
  }

  checkIfLoading(menuList: any) {
    let loading = false;
    if (this.getDialerType() != 'Keypad') {
      if (menuList.length <= 0) {
        loading = true;
      } else {
        loading = false;
      }
      this.loaderService.setOnDemandLoading(loading);
    } else if (this.getDialerType() == 'Keypad') {
      if (menuList.length <= 0) {
        loading = true;
      } else {
        loading = false;
      }
      if (menuList.length <= 0) {
        // this.loaderService.setOnDemandLoading(loading);
      }
    }

    return loading;
  }
  confirmUserNav(event) {
    this.ConfirmUserNav = event;
  }
  getenableDialManuallyStatus() {
    return this.mainController.getenableDialManuallyStatus();
  }
  getCallPromptStatus() {
    return this.mainController.getCallPromptStatus();
  }
  getkeypadCallPromptStatus() {
    return this.mainController.getkeypadCallPromptStatus();
  }
  getCallPromptReadOnlyStatus() {
    return this.mainController.getCallPromptReadOnlyStatus();
  }
  getCallPromptControlsActiveStatus() {
    return this.mainController.getCallPromptControlsActiveStatus();
  }
  getbackBtn() {
    //if (this.showhidebackbtn) {
    //    return true;
    //}
    //else if (this.mainController.getbackBtn()) {
    //    return true;
    //}
    //else if (!this.mainController.getbackBtn()) {
    //    return false;
    //}
    return this.mainController.getbackBtn();
  }
  // keypad start

  showDialpad() {
    this.addressBook = false;
    this.dialpad = true;
    // if(this.dialpad == true){
    //     this.addressBook = false
    // }else if(this.dialpad == false){
    //     this.addressBook = true
    // }
  }
  showAddressBook() {
    if (this.getDialerType() == 'Keypad') {
      this.contactNumList = this.mainController.getQueueInfoDetail()?.ExternalNumbers;
    }
    this.dialpad = false;
    this.addressBook = true;
    // if(this.addressBook == true){
    //     this.dialpad = false
    // }else if(this.addressBook = false){
    //     this.dialpad = true
    // }
  }

  StartOutboundCall() {
    this.tmQueueService.setstartOutboundCall({ status: true, OutBoundNumber: this.inputValue });
  }
  StartOutboundCallFromContact(item) {
    this.tmQueueService.setstartOutboundCall({ status: true, OutBoundNumber: item.Number });
  }
  getCallStatus() {
    return this.dialerService.getCallStatus();
  }

  onNumberPadBtnClick(value) {
   // console.log(value);
    var tone;
    //AWS Migration - ONV-1456 ( Hardcoded s3bucket name of AWS environment )
    switch (value) {
      case '#':
        tone = new Audio('https://common.cts-connect.com/Audio/pound.wav');
        break;
      case '*':
        tone = new Audio('https://common.cts-connect.com/Audio/star.wav');
        break;
      default:
        tone = new Audio('https://common.cts-connect.com/Audio/' + value + '.wav');
    }
    tone.play();

    this.inputValue += value;

    // this.appService.setNumberpadValue(value);
    // this.numberPadKeyPressedHandler(value)
  }

  StartCallActivity(item: any) {
    // this.dailerService.setPhoneNo(item.contactNumber);
    // this.OutBoundNumber = item.contactNumber;
    // this.checkCaseDetailFreeDial()
    // this.StartOutboundCall('FreeDial');
    // this.onCloseHandled();
  }
  onBackspace(): void {
    this.inputValue = this.inputValue.slice(0, -1);
    console.log(this.inputValue);
  }

  //   handleSelectedExisistingUser(event) {
  //     if (event && event.length == 1 && event != 'not-found') {
  //       this.Heading = '';
  //       this.selectedUserID = event[0].UserID;
  //       // this.selectedCaseId = null;
  //       this.showSearch = false;
  //       this.bsModalRef.hide();

  //       // this.fullName = event[0].FullName
  //       const data = {
  //         queueID: 89,
  //         userID: this.selectedUserID,
  //         company: 'S2U',
  //         user: this.user,
  //       };
  //       this.managerService.addExistingRecord(data).subscribe(res => {
  //         console.log(res);

  //         if (res) {
  //           this.bsModalRef.hide();

  //           const initialState = {
  //             contentMsg: 'Your requested record has been added to the queue.',
  //             confirmBtnValue: 'Ok',
  //             cancelBtnValue: '',
  //             isConfirm: true,
  //             isDelete: false,
  //           };

  //           const config: ModalOptions = {
  //             backdrop: 'static',
  //             class: 'confirm-dialog modal-wd-290',
  //             initialState,
  //           };

  //           this.modalRef = this.modalService.show(ConfirmDialogComponent, config);
  //           this.modalRef.content.event.subscribe((result: any) => {
  //             if (result.value == 'confirm') {
  //               console.log('create');
  //               this.modalRef.hide();
  //               // this.managerService.recordAdded.emit(res);
  //               // this.outboundComponent.loadQueues();
  //               // alert('hi')
  //               // this.router.navigate([this.clientAbbreviation + '/Queue/caseDetails']);
  //             }
  //           });
  //           this.bsModalRef.hide();
  //         }
  //       });
  //     }
  //   }
  getCaseForUser(userdata: any) {
    this.queueService
      .getCaseForUser(userdata)
      .pipe(
        map((data: any) => {
          const isValid = ResponseHandler.processResponse(data, 'GetCaseForUser');
          if (isValid) {
            this.CaseID = data.Response.Data;
            if (this.queueType == 'Outbound' || this.queueType == 'Inbound' || this.queueType == 'Search') {
                //if (this.mainController.getIsCaseUserUnmapped() && this.mainController.getUnmappedCaseID() != '') {
                //    this.appService.setTrigger_ClearoldCases(this.mainController.getUnmappedCaseID());
                //}
              this.HandleSearchUserRecords();
            }
          }
        }),
        catchError(error => {
          console.log(error);
          return EMPTY;
        })
      )
      .subscribe();
  }
  getActionItem() {
    const queueID = this.queueService.getselectedQueueId();
    const userID = this.selectedData[0] ? this.selectedData[0]?.UserID : null;
    // this.CaseID = this.CaseID ? this.CaseID : 0;
    return queueID + '-' + userID + '-' + this.CaseID;
  }
  HandleSearchUserRecords() {
    const actionItem = this.getActionItem();
    this.queueService.GetCaseLocks(this.CaseID).subscribe(data => {
      if (data.Response.Data.Agent != null) {
        this.selectedData.Locked = true;
        //set to read only mode
        this.selectedData.ActionItemID = actionItem + '-R';
        this.selectedData.LockedBy = data.Response.Data.Agent.ID;
        const initialState = {
          selectedData: this.selectedData,
        };
        const config: ModalOptions = {
          class: 'status-menu',
          backdrop: 'static',
          keyboard: false,
          initialState,
        };
        this.modalRef = this.modalService.show(CaseLockConfirmationComponent, config);
      } else {
        this.appService.setActionItemId(actionItem);
        this.router.navigate([this.clientAbbreviation + '/Queue/caseDetails']);
      }
    });
  }
  CreateExternalRecord(externalID: string, callback: (id: any) => void) {
    this.queueService.CreateExternalRecord(externalID).subscribe({
      next: res => {
        this.externalUserID = res.Response.Data;
        console.log('Received external user ID:', this.externalUserID);
        callback(this.externalUserID); // call the callback after getting the data
      },
      error: err => {
        console.error('Error creating external record:', err);
      },
    });
  }

  updateSelectedAgent(userRecord: any) {
    console.log(userRecord);
    this.selectedData = userRecord;
    //this.searchData = userRecord;
    this.searchData = {
      Response: {
        Data: [userRecord],
      },
    };
    this.GetCurrentOrSelectedRowUserID(userRecord);
    let params = this.appService.getSearchParameters();
    if (params[0].type == 'Case ID' && this.selectedData[0].UserID != -1) {
      this.getCaseID(params[0].value);
    } else if (this.selectedData && this.selectedData[0].UserID == -1) {
      this.CreateExternalRecord(this.selectedData[0].CrmUserID, externalID => {
        this.selectedData[0].UserID = externalID;
        this.getCaseForUser(this.selectedData);
      });
      // this.CreateExternalRecord(this.selectedData[0].CrmUserID);
      // console.log('Received external user ID:', this.externalUserID);
      // this.selectedData[0].userID = this.externalUserID;

      // this.getCaseForUser(this.selectedData);
      // console.log('selectedData:', this.selectedData);
    } else {
      this.getCaseForUser(userRecord);
    }
    this.queueService.setSelectedSearchRecord(userRecord);
  }
  GetCurrentOrSelectedRowUserID(data: any) {
    if (Array.isArray(data)) {
      this.userID = data[0].UserID;
    } else {
      this.userID = data.UserID;
    }
  }
  getCaseID(Id: any) {
    this.queueService
      .getCaseID(Id)
      .pipe(
        map((data: any) => {
          const isValid = ResponseHandler.processResponse(data, 'GetCaseID');
          if (isValid) {
            this.CaseID = data.Response.Data;
            if (this.queueType == 'Search' || this.queueType == 'Inbound') {
                  if (this.mainController.getUnmappedCaseID() && this.mainController.getUnmappedCaseID() != '') {
                      this.appService.setTrigger_ClearoldCases(this.mainController.getUnmappedCaseID());
                  }
                  this.HandleSearchUserRecords();
              }
          }
        }),
        catchError(error => {
          console.log(error);
          return EMPTY;
        })
      )
      .subscribe();
  }
  handleSelectedUser(event) {
    console.log(event);
    if (event == 'not-found') {
      const initialState = {
        contentMsg: 'This will create a new user record. Are you sure you would like to continue?',
        confirmBtnValue: 'Ok',
        cancelBtnValue: 'Cancel',
        isConfirm: true,
        isDelete: false,
      };

      const config: ModalOptions = {
        backdrop: 'static',
        class: 'confirm-dialog modal-wd-290',
        initialState,
      };

      this.modalRef = this.modalService.show(ConfirmDialogComponent, config);
      this.modalRef.content.event.subscribe((result: any) => {
        if (result.value == 'confirm') {
         // console.log('create');
          this.bsModalRef.hide();
          // const actionItem = this.getActionItem();
          this.appService.setActionItemId(this.queueID + '-' + null + '-' + 0);
          this.router.navigate([this.clientAbbreviation + '/Queue/caseDetails']);
        } else {
          this.modalRef.hide();
        }
        this.modalRef.hide();
      });
    }
  }
  getSelectedUserID(): any{
    let selectedNewUserId = this.queueService.getSelectedNewUserId();
    return this.selectedUserID != null ? this.selectedUserID : selectedNewUserId != null ? selectedNewUserId : 0;
  }
  // keypad end
    toggleNewUser() {
        if (this.queueService.GetVoicemailDetailsReply() && (this.selectedUserID == '0' || this.selectedUserID == null)) {
            return;
        }
        else if (this.queueService.GetVoicemailDetailsReply() && this.selectedUserID != '0' && this.selectedUserID != null && this.newUser === 'New User') {
            return;
        }
        if (this.newUser === 'New User') {
            //this.userInfo = null;
            this.appService.setIsAddNewUser(true);
            this.queueService.setIsNewUser({ cleardata: true, isnewUser: true });
            this.clearUserInfo();
        }
        else {
            this.appService.setIsAddNewUser(false);
            this.queueService.setIsNewUser({ cleardata: true, isnewUser: false });
        }
        if (this.mainController.getshowSearchDialog()) {
            this.mainController.setshowSearchDialog(false);
        }
        else {
            this.mainController.setshowSearchDialog(true);
        }
        if (this.mainController.getIsCaseUserUnmapped() && this.selectedUserID != '0' && this.selectedUserID != null && this.newUser == 'Change User') {
            this.mainController.setshowSearchDialog(true);
            this.queueService.showElsePart();
        }
        else {
            this.newUser = this.newUser === 'New User' ? 'Change User' : 'New User';
            if (this.newUser === 'New User') {
                //this.appService.setIsAddNewUser(true);

                this.queueService.showElsePart();
            } else {
                this.queueService.hideElsePart();
            }
        }

        if (this.newUser == 'New User') {
            this.mainController.setshowSearchDialog(true);
        }

        this.queueService.showUserInfoTab();


        this.changeUser();


    }
  changeUser() {
    this.queueService.triggerBackClicked(0);

    // this.location.back();
    // this.dataToDisplay = this.searchData.Response.Data;
    // if (this.searchData?.Response?.Data) {
    //   this.dataToDisplay = this.searchData.Response.Data;
    //   this.queueService.triggerBackClicked(0);
    //   //this.emitBackClicked.emit(0);
    // }
  }
  setNewUserToChange() {
    if (this.newUser === 'New User') {
      this.newUser = 'Change User';
      this.changeUser();
    }
  }
  filterPayload(payload) {
    this.caseDetailsConf?.Tabs?.forEach(tab => {
      if (tab.TabValue) {
        let tabData = payload[tab?.TabValue];
        if ((Array.isArray(tabData) && tabData?.length > 0) || !(Array.isArray(tabData) && tabData != null)) {
          tab?.Groups?.forEach(group => {
            group.Fields?.forEach(field => {
              if (Array.isArray(tabData)) {
                if (field?.saveFieldInteraction != undefined && !field?.saveFieldInteraction) {
                  tabData.forEach(tabData => {
                    delete tabData[field?.Name];
                  });
                }
              } else {
                if (field?.saveFieldInteraction != undefined && !field?.saveFieldInteraction) {
                  if (tabData != undefined) delete tabData[field?.Name];
                }
              }
            });
          });
          payload[tab.TabValue] = tabData;
        }
      }
    });
    return payload;
  }
  // Toggle the right panel collapse state
  toggleRightPanel(): void {
    this.isRightPanelCollapsed = !this.isRightPanelCollapsed;
    // Save state to localStorage
    localStorage.setItem('rightPanelCollapsed', this.isRightPanelCollapsed.toString());
  }

  addDialedNumber() {
    let fieldID = this.formDataService.generateFieldIDFromCD(this.caseDetailsConf);
    if (fieldID) {
      let newPhoneNumber = {
        id: fieldID,
        name: this.dialerService.getphoneNumberType(),
        value: this.dialerService.getPhoneNo(),
      };
      // Check for full duplicate (id, name, and value)
      let exists = this.allDynamicTabsData.userInformation.PhoneNumbers.some(
        item =>
          item.id === newPhoneNumber.id || (item.name === newPhoneNumber.name && item.value === newPhoneNumber.value)
      );
      if (!exists) {
        this.allDynamicTabsData.userInformation.PhoneNumbers.push(newPhoneNumber);
      }
    }
    }

    //Call failure modal
    closeValidationModal(): void {
        //this.showValidationModal = false;
        //this.validationModalDisplay = 'none';
        //this.validationErrorMessage = '';
        //this.bsModalRef.hide();
        this.mainController.resetValidationModal();
    }
    getValidationModalStatus() {
        return this.mainController.showValidationModal;
    }
    getvalidationErrorMessage() {
        return this.mainController.validationErrorMessage;
    }
    getDisplayvalidationModal() {
        return this.mainController.validationModalDisplay;
    }
    getHideUnknownContact() {
        return this.mainController.getHideUnknownContact();
    }
    isValidDispositionSelected(): boolean {
        return this.selectedCallDisposition && this.selectedCallDisposition.value !== 0;
    }

    submitFailure(): void {
        // Handle call failure submission with selected disposition and notes
        console.log('disposition:', this.selectedCallDisposition.label, ' - ', this.selectedCallDisposition.value);
        console.log('notes:', this.callNotes);
        this.mainController.isSubmitfailurePopupdisplayed = false;
        let callID = this.queueService.getCallID() || '';
        let activityID = this.ActionItemID || '';
        let interactionID = this.queueService.getCallID()?.trim() ? this.queueService.getInteractionID() : '';

        let enterRecorddet: any;
        try {
            if (this.mainController.getEnterRecord() != '') {
                enterRecorddet = new Date(this.mainController.getEnterRecord()).getTime();
            }
            //enterRecorddet= (this.mainController.getEnterRecord() != '') ? this.mainController.getEnterRecord().getTime() : ''
        } catch (e) { }

        this.appService.activityId.subscribe(value => {
            activityID = value;
        });

        this.tmQueueService.submitFailure(callID, this.selectedCallDisposition.value, activityID, this.callNotes, this.selectedUserID, enterRecorddet, interactionID).subscribe({
            next: (response) => {
                console.log('Call failure submitted successfully:', response);
                this.closeValidationModal();
                this.queueService.SetDisableHeader(false);
                //this.router.navigate([Utils.fetch('clientAbbreviation') + '/Queue']);
                this.handleRedirection('');
            },
            error: (error) => {
                console.error('Error submitting call failure:', error);
            }
        });
        this.dialerService.setPhoneNo(''); 
    }

    addMoreTime(){
        //this.dispositionTimerSeconds += Math.floor(this.dispositionTimerDuration / 2);
        //this.showAddMoreTime = false;
        this.mainController.eRequestMoreTimeHandler();
    }

    showPostcalloutTimer() {

        return (this.mainController.postCallTimeoutAlert)
    }
    showPostcalloutText() {

        return (this.mainController.postCallTimeoutText)
    }
    showPostcallAddMoreTimeAlert() {

        return (this.mainController.requestMoreTimeBtn)
    }
    getIsCaseUserUnmapped() {

        return this.mainController.getIsCaseUserUnmapped();
    }
    getshowSearchDialog() {

        return this.mainController.getshowSearchDialog();
    }
    generateNotesContent(_notes: string, oldNotes: string, user: any): string {
      if (!this.notesHelper.isEmptyOrWhitespace(_notes)) {
        return this.notesHelper.encodeUnicodeText(_notes);
      }
      return '';
    } 
    searchCallHistoryByCaseId() {
      
       this.first = 0;
       this.currentPage = 1;
       this.isCaseHistorySearchActive = true;
       this.loading = true;
       const filterDict = [
        {
          Key: 'CaseId',
          Value: [this.callHistorySearchTerm]
        }
      ];
      this.queueService
        .getCallHistory(
          this.selectedUserID,
          1,
          this.queueService.getCallID(),
          filterDict
        )
        .subscribe({
          next: (res: any) => 
            {
      const data = res?.Response?.Data;
      const records = data?.ItemsList?.[0] || [];
      records.forEach((item: any) => {
      item.custTtype =
      item.NumberCalled &&
       item.Type?.toLowerCase() !== 'nointeraction'
      ? 'Call'
      : 'No Interaction';
       });
            this.paginatedData = records;
            this.TotalItemCount = data?.TotalItemCount || 0;
    
            this.loading = false;
          },
          error: () => 
            {
            this.loading = false;
          }
        });
    }
   
    clearCaseHistorySearch() 
    {
      this.isCaseHistorySearchActive = false;
      this.callHistorySearchTerm = '';
      this.first = 0;
      this.currentPage = 1;
    
      this.getCallHistoryDetails(1);
    }
   
    onCaseHistorySearchChange() 
    {
      if (!this.callHistorySearchTerm?.trim()) {
        this.clearCaseHistorySearch();
      }
    }
    getVoicemailTranscript(interactionId: number) {
      this.transcriptService
        .GetPostCallAnalyticsByInteractionID(interactionId, 3)
        .subscribe(
          (res: any) => {
   
            const transcriptData = res?.Response?.Data;
   
            if (transcriptData?.Sentences?.length) {
   
              this.voicemailTranscriptSpeaker =
                transcriptData.Sentences[0]?.SpeakerRole || 'Transcript';
   
              this.voicemailTranscriptDate =
                transcriptData.Sentences[0]?.TimeStamp || '';
   
                this.voicemailTranscript =
                transcriptData.Sentences
                  .map((x: any) => x.Transcript)
                  .join('\n\n');
            }
          },
          err => {
            console.log('Voicemail Transcript Error', err);
          }
        );
    }
}
